// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:07.325Z
// Property: Prairie Springs (ID: 6767906449165621)
// Collections: 17 amenities, 15 floorplans (live), 23 photos, 70 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165621",
  "property_external_id": "48t4k4k",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/prairie-springs-oklahoma-city-ok/48t4k4k/",
  "property_google_business_url": "https://www.google.com/maps/place/Prairie+Springs/data=!4m2!3m1!1s0x0:0x7f14f93449e20c3c?sa=X&ved=2ahUKEwjV9MmC_rySAxXAmGoFHYQgOF4Q_BJ6BAg5EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "prairie-springs-i",
  "property_name": "Prairie Springs",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/prairie-springs/",
  "property_domain": null,
  "property_address": "9777 North Council Road",
  "property_full_address": "9777 North Council Road, Oklahoma City, Oklahoma City, 73162",
  "property_address_1": "9777 North Council Road",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73162",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Harvest Hills",
  "property_address_latitude": "35.57055",
  "property_address_longitude": "-97.65686",
  "property_email": "prairiesprings@caseusa.com",
  "property_phone": "(844) 899-7238",
  "property_call_tracking_phone": "844-899-7238",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Prairie Springs in Oklahoma City, where comfort meets convenience. Choose from our one, two, or three-bedroom floor plans featuring walk-in closets, vaulted ceilings, and private balconies. Enjoy a laid-back lifestyle with our sparkling pool, fitness center, and dog park. Find your new home today—browse availability or schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Prairie Springs, your serene oasis in the heart of Oklahoma City! Our thoughtfully designed apartment community offers a variety of stylish floor plans, including one-bedroom, two-bedroom, and three-bedroom options, perfectly suited for your lifestyle. Each home is equipped with desirable amenities such as lofty vaulted ceilings, spacious walk-in closets, and cozy fireplaces, making it easy to create a warm and inviting atmosphere.\n\nAt Prairie Springs, we prioritize both relaxation and recreation. Dive into our sparkling pool, maintain your fitness goals at our well-equipped fitness center, or unwind at our welcoming clubhouse. For busy professionals, our on-site business center ensures you have a productive space right at your fingertips. The convenience of on-site laundry facilities and maintenance, along with a dedicated property manager, takes the hassle out of everyday living.\n\nYour furry friends are not left behind—our community features a spacious dog park, ensuring they have ample room to romp and play. Experience the added peace of mind with gated access, allowing you to feel secure in your new home. Both balconies and patios extend your living space outdoors, perfect for enjoying the scenic views of our lush surroundings.\n\nDon’t miss out on finding your dream apartment at Prairie Springs! With high-speed internet access, washer/dryer hookups, and an environment designed for comfort and convenience, your new home awaits. Browse our availability or schedule a tour today to experience our inviting community firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb46-a140-73e2-a7b2-56d0e9c2d207.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor spa and pool area with lounge chairs and surrounding apartment buildings.",
    "public_id": "019cfb46-a140-73e2-a7b2-56d0e9c2d207",
    "storage_key": "property/6767906449165621/019cfb46-a140-73e2-a7b2-56d0e9c2d207.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "462",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.45454545454545",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "0",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of 2 pets, with weight limits of up to 40 lb or between 40–80 lb.",
  "property_pet_policy_description": "We welcome cats and dogs. One-time pet fee: $400 and monthly pet rent: $30 for pets up to 40 lb (max 2 pets); one-time pet fee: $500 and monthly pet rent: $30 for pets 40–80 lb (max 2 pets).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://prairiespringsapartmentsoklahomacity.securecafe.com/onlineleasing/prairie-springs-i/floorplans.aspx",
  "property_resident_portal_url": "https://prairiespringsapartmentsoklahomacity.securecafe.com/residentservices/prairie-springs-i/userlogin.aspx",
  "property_apply_now_url": "https://prairiespringsapartmentsoklahomacity.securecafe.com/onlineleasing/prairie-springs-i/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-5f0d-7297-a5d0-030c04bf4e54.webp",
  "property_primary_logo_media": {
    "alt_text": "Prairie Springs Apartments logo with white grass graphic and text on black background.",
    "public_id": "019cfb45-5f0d-7297-a5d0-030c04bf4e54",
    "storage_key": "property/6767906449165621/019cfb45-5f0d-7297-a5d0-030c04bf4e54.webp",
    "width": 1593,
    "height": 708
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb46-933c-7255-a803-a90fd926e956.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb46-933c-7255-a803-a90fd926e956",
    "storage_key": "property/6767906449165621/019cfb46-933c-7255-a803-a90fd926e956.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb46-b08d-77d8-9853-b97e46111745.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Prairie Springs Apartments logo with white grass graphic on black background.",
    "public_id": "019cfb46-b08d-77d8-9853-b97e46111745",
    "storage_key": "property/6767906449165621/019cfb46-b08d-77d8-9853-b97e46111745.webp",
    "width": 640,
    "height": 284
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb46-bacc-7282-851d-54178004d380.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Prairie Springs Apartments logo with silhouette of grass.",
    "public_id": "019cfb46-bacc-7282-851d-54178004d380",
    "storage_key": "property/6767906449165621/019cfb46-bacc-7282-851d-54178004d380.webp",
    "width": 640,
    "height": 284
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#660b11",
  "property_secondary_color": "#16618e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "692 - 1447",
  "property_sqft_min": "692",
  "property_sqft_max": "1,447",
  "property_price_range": "919 - 1589",
  "property_price_min": "919",
  "property_price_max": "1589",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/PrairieSpringsOKC/photos/d41d8cd9/1663995474957442/",
  "property_instagram_url": "https://www.instagram.com/prairiespringsokc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_cPWfgAFsocRy4J3ERpkOqE",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Oklahoma+City%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/@prairie.springs",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Prairie Springs I",
  "property_home_romance_title": "Create Lasting Memories in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "At Prairie Springs in Oklahoma City, your ideal living space awaits. Choose from thoughtfully designed one, two, or three-bedroom apartments featuring modern amenities like a sparkling pool, state-of-the-art fitness center, and a serene dog park. Embrace comfort with vaulted ceilings, private balconies, and convenient on-site maintenance. Experience home redefined!",
  "property_home_floorplans_blurb": "At Prairie Springs in Oklahoma City, we offer a harmonious blend of comfort and style with our thoughtfully designed one, two, and three-bedroom apartments. Each floor plan is crafted to elevate your living experience. Browse our available homes today and uncover the ideal space that suits your lifestyle.",
  "property_home_gallery_blurb": "Welcome to Prairie Springs in the heart of Oklahoma City, where comfort meets convenience. Choose from one, two, or three-bedroom floor plans with stylish features like vaulted ceilings and private patios. Enjoy amenities like a sparkling pool, fitness center, and dog park. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Prairie Springs in Oklahoma City, you’ll find the perfect blend of comfort and convenience. Our spacious one, two, and three-bedroom apartments are just moments away from tranquil parks, engaging libraries, and Southern Nazarene University. Embrace a lively community filled with enriching experiences—find your new home today!",
  "property_home_reviews_blurb": "At Prairie Springs in Oklahoma City, our residents often express their gratitude for our attentive staff and stunning surroundings. One resident shares, \"Prairie Springs has been the nicest apartment complex I've ever had the privilege of living in.\" Experience a warm, friendly community where comfort and care come first!",
  "property_neighborhood_blurb": "At Prairie Springs in Oklahoma City, your lifestyle is enriched by vibrant community connections. Just steps from stunning parks, educational institutions, and recreational gems like Martin Park Nature Center and Lake Overholser, adventure and relaxation await. Embrace the charm of local libraries and universities while savoring every moment. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Prairie Springs in Oklahoma City, lifestyle meets comfort with our spacious one, two, and three-bedroom apartments. Enjoy amenities like a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. Embrace community living with an on-site dog park, gorgeous vaulted ceilings, and private balconies that elevate everyday life.",
  "property_applynow_blurb": "At Prairie Springs in vibrant Oklahoma City, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy amenities like a refreshing pool, state-of-the-art fitness center, and a cozy clubhouse. Embrace comfort with walk-in closets, high-speed internet, and a dog park. Lease your new home online today!",
  "property_contactus_blurb": "At Prairie Springs in Oklahoma City, thoughtfully designed one, two, and three-bedroom floor plans await your personal touch. Each spacious layout harmonizes comfort and style, perfect for making unforgettable memories. Have questions? Our friendly leasing team is ready to help you find your ideal home—reach out today!",
  "property_faqs_blurb": "At Prairie Springs in Oklahoma City, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Have questions? Our FAQs page is your go-to resource for insights into our vibrant community and amenities. Uncover the answers you seek today!",
  "property_floorplans_blurb": "At Prairie Springs in Oklahoma City, spacious living awaits with our thoughtfully designed floor plans tailored for every lifestyle. Whether you seek a cozy one-bedroom retreat, a versatile two-bedroom, or a family-friendly three-bedroom, you'll find the perfect fit. Browse our available apartment homes today and elevate your living experience!",
  "property_gallery_blurb": "At Prairie Springs in Oklahoma City, every moment feels like a retreat. Choose from spacious one, two, or three-bedroom layouts that blend comfort and style. With a pool, fitness center, and dog park, life here transcends the ordinary. Picture yourself lounging on your balcony or relaxing by the fireplace!",
  "property_interactivemap_blurb": "At Prairie Springs in Oklahoma City, modern living meets comfort. Choose from spacious one to three-bedroom apartments with amenities like a refreshing pool, a state-of-the-art fitness center, and a relaxing dog park. Ready to find your perfect home? Use our interactive community map for available options and pricing!",
  "property_pets_blurb": "At Prairie Springs I in vibrant Oklahoma City, our spacious apartments are the perfect backdrop for your lifestyle. With our pet-friendly policy, furry friends can join in the fun—your cozy retreat awaits, complete with lush amenities and a welcoming community atmosphere that feels like home. ",
  "property_referafriend_blurb": "At Prairie Springs in Oklahoma City, spacious one, two, and three-bedroom apartments await, offering a perfect blend of comfort and style. Great friends make great neighbors—refer a friend today and share the joys of our welcoming community, where every corner feels like home.",
  "property_residentaccess_blurb": "Welcome to Prairie Springs, where comfort meets convenience in Oklahoma City. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, tailored to fit your lifestyle. Access your resident portal today to manage rent payments, schedule maintenance, and enjoy seamless living at its finest!",
  "property_reviews_blurb": "At Prairie Springs in Oklahoma City, our residents celebrate a vibrant community where kindness flourishes. With a perfect blend of attentive staff and serene surroundings, many describe their experience as a \"great place to call home.\" Join us and see why so many choose to thrive in our welcoming haven!",
  "property_created_at": "1753982389910",
  "property_scheduletour_blurb": "At Prairie Springs in Oklahoma City, our diverse floor plans—including one, two, and three-bedroom options—cater to your lifestyle. Schedule a tour today and immerse yourself in the vibrant community that our residents love. Experience firsthand the charm and comfort that await you at Prairie Springs!",
  "property_thankyou_blurb": "Thank you for reaching out! At Prairie Springs in vibrant Oklahoma City, our thoughtfully designed floor plans—including one, two, and three-bedroom options—cater to your unique lifestyle. Keep an eye on your inbox; a member of our friendly team will be in touch soon to assist you further.",
  "property_virtualtours_blurb": "Step into Prairie Springs, where spacious one, two, and three-bedroom apartments await you in vibrant Oklahoma City. With an array of thoughtfully designed floor plans, your ideal home is just a click away. Dive into our virtual tour and envision your life at Prairie Springs today!",
  "property_copyright": "2025 All Rights Reserved. Prairie Springs",
  "property_seo_title_home": "Prairie Springs |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Find your perfect fit at Prairie Springs in OKC! Enjoy spacious floor plans, resort-style amenities, and a welcoming community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Prairie Springs in Oklahoma City! Choose from stylish one, two, or three-bedroom floor plans tailored to your lifestyle.",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Prairie Springs in Oklahoma City! Enjoy amenities like a pool, fitness center, and dog park. Spacious one to three-bedroom floor plans await you!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Capture the essence of Oklahoma City living at Prairie Springs. From stunning floor plans to inviting amenities, picture your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Prairie Springs Apartments",
  "property_seo_description_virtualtours": "Explore Prairie Springs in OKC! Take a virtual tour of stunning one to three-bedroom floor plans designed just for you. Discover your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Prairie Springs Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Prairie Springs in Oklahoma City! Use our interactive map to explore one to three-bedroom apartments and exceptional amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Experience the vibrant neighborhood of Prairie Springs in Oklahoma City. Uncover local gems, parks, and dining hotspots just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Prairie Springs",
  "property_seo_description_contact": "Connect with Prairie Springs in Oklahoma City! Our leasing team is ready to answer your questions about our spacious one, two, and three-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Get answers to your questions at Prairie Springs, OKC! Our FAQs cover floor plans, amenities, and everything else about your new home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Join the Prairie Springs community in OKC! Hear residents share their love for our amenities and stunning floor plans.",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Experience modern living at Prairie Springs in Oklahoma City! Choose from spacious floor plans and enjoy amenities like a pool, fitness center, and dog park.",
  "property_seo_title_residentaccess": "Resident Access | Prairie Springs",
  "property_seo_description_residentaccess": "Manage your Prairie Springs lifestyle! Log in to the resident portal for rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Prairie Springs",
  "property_seo_description_referafriend": "Refer a friend to Prairie Springs in Oklahoma City! Great friends make great neighbors—share our vibrant community and enjoy exclusive rewards together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Prairie Springs",
  "property_seo_description_scheduletour": "Experience the charm of Prairie Springs in Oklahoma City. Schedule a tour today and step into your ideal apartment home surrounded by vibrant community living!",
  "property_seo_title_privacy": "Privacy Policy | Prairie Springs",
  "property_seo_description_privacy": "At Prairie Springs in Oklahoma City, your privacy matters. Learn how we protect your data and ensure your Peace of Mind. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Prairie Springs",
  "property_seo_description_accessibility": "Embrace accessibility at Prairie Springs in Oklahoma City, where everyone belongs. Our commitment to digital inclusion ensures a welcoming experience for all.",
  "property_seo_title_sitemap": "Sitemap | Prairie Springs",
  "property_seo_description_sitemap": "Uncover the hidden gems of Prairie Springs in Oklahoma City! Navigate our sitemap for an easy overview of amenities, floor plans, and community offerings.",
  "property_seo_title_thankyou": "Thank You | Prairie Springs",
  "property_seo_description_thankyou": "Thanks for contacting Prairie Springs in OKC! Our team will be in touch soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, Oklahoma City",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865639121",
  "amenities": [
    {
      "id": "custom_c0325397-dccc-4144-a63c-84e3e2a4cf78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c23edf69-1601-4af6-abef-d9d677311b12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Modern, Fully Equipped Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff008aea-298c-4f11-9143-d2014dea7daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Attached & Detached Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b969532-478d-4e6c-bc77-3d9f6b666b8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eeec1847-1034-4f6a-8696-2aceb2ce70c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ee54d74-196f-45a5-b71a-456caea65198",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Resort-Inspired Swimming Pool and Sundeck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b87dac3-8923-4cb0-b499-2b62b5be8b37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a02006d-e20a-4cb2-8cd6-473a613b7e7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e6980d4d-7252-4660-82f5-387d476ed0a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2848282-369d-405b-9e99-ab9d5f8c172b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Premium Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d59d1f5-b6ce-4f03-be24-40b631af5b3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Burning Fireplace*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_270ac741-2687-4462-b350-be7f7464d4ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2a9f4fc-d45f-44ce-a51e-48ecba12229a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5db05360-b979-41fb-b64b-34e97c7557f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony/Patio*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73f7940d-a61a-4572-a547-b3bfb6c86dac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53ede90f-e434-41d6-bcb4-2148f6d119f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Chef’s Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e379777-70a0-464a-9827-bd6856ee43d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "external_id": "false",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1c188d4e-6238-4826-ada7-37353a620a8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-9769-717b-a36d-9ec996c4369d.webp",
      "image_media": {
        "alt_text": "Stone entrance sign with Prairie Springs branding, flanked by colorful flower beds and trees.",
        "public_id": "019d20af-9769-717b-a36d-9ec996c4369d",
        "storage_key": "property/6767906449165621/019d20af-9769-717b-a36d-9ec996c4369d.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Entry sign and landscaped grounds for Prairie Springs, welcoming residents with stone pillars and vibrant flowers.",
      "link": "",
      "alt_text": "Stone entrance sign with Prairie Springs branding, flanked by colorful flower beds and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5fb5-7692-accc-5bd3aa9c8ee7.webp"
    },
    {
      "id": "custom_50c5a7be-27b4-4144-b994-e69a18eb6958",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-97c0-75aa-866a-e234c6a60d15.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment complex with a central pond and fountain.",
        "public_id": "019d20af-97c0-75aa-866a-e234c6a60d15",
        "storage_key": "property/6767906449165621/019d20af-97c0-75aa-866a-e234c6a60d15.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "A scenic apartment community with low-rise buildings, lush lawns, and a decorative fountain pond in the foreground.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment complex with a central pond and fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5fae-761f-8aba-a17c4197e9bc.webp"
    },
    {
      "id": "custom_79034f33-99ce-4982-8590-b2fcde770cbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-9738-7205-b092-4bfae92ebe58.webp",
      "image_media": {
        "alt_text": "Open grassy community courtyard with playground equipment and apartment buildings in the background.",
        "public_id": "019d20af-9738-7205-b092-4bfae92ebe58",
        "storage_key": "property/6767906449165621/019d20af-9738-7205-b092-4bfae92ebe58.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Exterior community space at a multifamily property featuring a green lawn, a fenced play area, and surrounding apartment buildings.",
      "link": "",
      "alt_text": "Open grassy community courtyard with playground equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5fbe-715f-aac8-c05b2efa1ea6.webp"
    },
    {
      "id": "custom_186572d9-cd59-4757-a354-4f41fa8188d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-975b-75f1-b358-fe87b3a9b6e4.webp",
      "image_media": {
        "alt_text": "Outdoor communal swimming pool with lounge chairs and a pond beyond, with apartment buildings in the background.",
        "public_id": "019d20af-975b-75f1-b358-fe87b3a9b6e4",
        "storage_key": "property/6767906449165621/019d20af-975b-75f1-b358-fe87b3a9b6e4.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Sunny outdoor pool area with lounge chairs and scenic views of the pond and surrounding apartment buildings.",
      "link": "",
      "alt_text": "Outdoor communal swimming pool with lounge chairs and a pond beyond, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5fbe-715f-aac8-c73e62f8e5d9.webp"
    },
    {
      "id": "custom_8ee88a9e-363b-4a17-acbc-72e8a3b5fd2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-a2b8-716b-b4f0-06cc90f0752c.webp",
      "image_media": {
        "alt_text": "Leasing office in a community room with a wooden table, four chairs, wall art, and a mounted TV.",
        "public_id": "019d20af-a2b8-716b-b4f0-06cc90f0752c",
        "storage_key": "property/6767906449165621/019d20af-a2b8-716b-b4f0-06cc90f0752c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Community lounge/office with a wooden table, four chairs, decorative wall accents, a mounted TV, and a rustic cabinet.",
      "link": "",
      "alt_text": "Leasing office in a community room with a wooden table, four chairs, wall art, and a mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5ed4-732a-a939-21ad7a701baf.webp"
    },
    {
      "id": "custom_4be0617f-abdd-407a-ad4b-23864f3749c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-a34a-76de-bcf7-cee9d820ee49.webp",
      "image_media": {
        "alt_text": "Interior of a modern gym with treadmills, cardio machines, mirrored walls, and windows.",
        "public_id": "019d20af-a34a-76de-bcf7-cee9d820ee49",
        "storage_key": "property/6767906449165621/019d20af-a34a-76de-bcf7-cee9d820ee49.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Bright community gym at the property featuring cardio equipment, free weights, and mirrored walls.",
      "link": "",
      "alt_text": "Interior of a modern gym with treadmills, cardio machines, mirrored walls, and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5fae-761f-8aba-9c3fa9490263.webp"
    },
    {
      "id": "custom_67d22236-549f-4ad3-8048-e08f0ed7001e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-a4d2-7569-a6d0-5d430f76b555.webp",
      "image_media": {
        "alt_text": "Stone entry sign at Prairie Springs with a landscaped bed and colorful flowers.",
        "public_id": "019d20af-a4d2-7569-a6d0-5d430f76b555",
        "storage_key": "property/6767906449165621/019d20af-a4d2-7569-a6d0-5d430f76b555.webp",
        "width": 698,
        "height": 797
      },
      "title": "Community",
      "description": "Entrance sign for the Prairie Springs apartment community, set in a stone surround with blooming landscaping.",
      "link": "",
      "alt_text": "Stone entry sign at Prairie Springs with a landscaped bed and colorful flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-7bf0-7168-ac30-36fffd7367a7.webp"
    },
    {
      "id": "custom_7c7fad56-051a-48e3-8f14-7cce0b6fbea2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-a83c-73e1-97a0-aef55cff26dc.webp",
      "image_media": {
        "alt_text": "Entrance to Prairie Springs apartment community with landscaped entry sign.",
        "public_id": "019d20af-a83c-73e1-97a0-aef55cff26dc",
        "storage_key": "property/6767906449165621/019d20af-a83c-73e1-97a0-aef55cff26dc.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Community",
      "description": "Exterior view of the Prairie Springs apartment community featuring the landscaped entry sign and brick facade.",
      "link": "",
      "alt_text": "Entrance to Prairie Springs apartment community with landscaped entry sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3f51-70d8-ad13-5076ba99155b.webp"
    },
    {
      "id": "custom_bd06c8cd-f4d8-49c4-9fb9-161695b7e9d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-b145-7054-8269-d49a34e968f0.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-family apartment community with a pond, fountain, and landscaped grounds.",
        "public_id": "019d20af-b145-7054-8269-d49a34e968f0",
        "storage_key": "property/6767906449165621/019d20af-b145-7054-8269-d49a34e968f0.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Community",
      "description": "Scenic exterior of a modern apartment community featuring a tranquil pond with a fountain, manicured lawns, and lush surroundings.",
      "link": "",
      "alt_text": "Exterior view of a multi-family apartment community with a pond, fountain, and landscaped grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3f7d-722c-8486-4ea8807775fb.webp"
    },
    {
      "id": "custom_468a45aa-787a-4172-b480-cbddcb4f2471",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-adba-75f5-a109-6fba08f00233.webp",
      "image_media": {
        "alt_text": "Outdoor communal pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019d20af-adba-75f5-a109-6fba08f00233",
        "storage_key": "property/6767906449165621/019d20af-adba-75f5-a109-6fba08f00233.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Community",
      "description": "An inviting outdoor pool at a residential community with sun loungers, trees, and surrounding apartment buildings.",
      "link": "",
      "alt_text": "Outdoor communal pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3eb9-76dc-94b7-55aecb12299c.webp"
    },
    {
      "id": "custom_fc1a989c-5d3e-4896-a5ea-3e5d9ca7b710",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-b405-70a7-b827-3678ccb607ab.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment community with a fenced playground and green lawn.",
        "public_id": "019d20af-b405-70a7-b827-3678ccb607ab",
        "storage_key": "property/6767906449165621/019d20af-b405-70a7-b827-3678ccb607ab.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with manicured lawns, walkways, and a fenced playground.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment community with a fenced playground and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3f51-70d8-ad13-4c68a35d5392.webp"
    },
    {
      "id": "custom_e7be2353-5ad4-4059-9aec-acd997418443",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-b6ad-7377-98ef-171f92327504.webp",
      "image_media": {
        "alt_text": "Bright kitchen with white cabinets, a fridge, and open pantry shelves.",
        "public_id": "019d20af-b6ad-7377-98ef-171f92327504",
        "storage_key": "property/6767906449165621/019d20af-b6ad-7377-98ef-171f92327504.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white appliances, a breakfast island, and open pantry storage.",
      "link": "",
      "alt_text": "Bright kitchen with white cabinets, a fridge, and open pantry shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5e9a-74ae-9e90-810431775356.webp"
    },
    {
      "id": "custom_71c2a9c0-94b2-4e3f-afe0-c381c20bbc36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-b73b-74ab-885c-de63d01176f9.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a beige sectional, patterned chair, and sliding glass door to the balcony.",
        "public_id": "019d20af-b73b-74ab-885c-de63d01176f9",
        "storage_key": "property/6767906449165621/019d20af-b73b-74ab-885c-de63d01176f9.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright living room in an apartment with a beige sectional, patterned chair, coffee table, and balcony access.",
      "link": "",
      "alt_text": "Living room in an apartment with a beige sectional, patterned chair, and sliding glass door to the balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5fb7-7538-b85d-561cd9df21f7.webp"
    },
    {
      "id": "custom_ae08aedd-7eb0-4c89-9743-d03557843ec5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-bbdf-74ec-b2b4-5ccf015d8368.webp",
      "image_media": {
        "alt_text": "Home office in an apartment with a wooden desk, computer, clock, and rustic sideboard.",
        "public_id": "019d20af-bbdf-74ec-b2b4-5ccf015d8368",
        "storage_key": "property/6767906449165621/019d20af-bbdf-74ec-b2b4-5ccf015d8368.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Stylish apartment workspace featuring a solid wood desk, computer setup, wall TV, and a rustic cabinet with decorative accents.",
      "link": "",
      "alt_text": "Home office in an apartment with a wooden desk, computer, clock, and rustic sideboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3f50-75cb-8587-e2b6a5eddcef.webp"
    },
    {
      "id": "custom_c7113e88-b13b-4288-b5c9-5f18b21f2e6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-bfbf-7585-8e0f-c3fa1343d2f4.webp",
      "image_media": {
        "alt_text": "Kitchen in apartment with brown wood cabinets, white appliances, and a double sink.",
        "public_id": "019d20af-bfbf-7585-8e0f-c3fa1343d2f4",
        "storage_key": "property/6767906449165621/019d20af-bfbf-7585-8e0f-c3fa1343d2f4.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen featuring brown wood cabinets, granite-like countertops, and white appliances (fridge, stove, microwave).",
      "link": "",
      "alt_text": "Kitchen in apartment with brown wood cabinets, white appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3f4e-702a-8c4c-03b7262e2237.webp"
    },
    {
      "id": "custom_0f32bf72-43c2-40f3-9a8e-97000a2dd784",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-c056-7178-ad6d-d1dee570f410.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, island counter, and open pantry shelves.",
        "public_id": "019d20af-c056-7178-ad6d-d1dee570f410",
        "storage_key": "property/6767906449165621/019d20af-c056-7178-ad6d-d1dee570f410.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with white appliances, an island, and an open pantry with organized staples.",
      "link": "",
      "alt_text": "Kitchen with white refrigerator, island counter, and open pantry shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3eb5-77ea-bd49-29c297a0c2eb.webp"
    },
    {
      "id": "custom_5295f99b-2d73-449e-b9ad-6e4bc086281d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-c0c0-72ba-be40-035f047399cc.webp",
      "image_media": {
        "alt_text": "Living room and dining area in a furnished apartment with sofa, chairs, coffee table, and TV.",
        "public_id": "019d20af-c0c0-72ba-be40-035f047399cc",
        "storage_key": "property/6767906449165621/019d20af-c0c0-72ba-be40-035f047399cc.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Bright, furnished apartment living space with a dining area, seating, and a TV setup.",
      "link": "",
      "alt_text": "Living room and dining area in a furnished apartment with sofa, chairs, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3f39-72b1-bc80-37ca371dae91.webp"
    },
    {
      "id": "custom_106fe589-9197-438d-9b22-dafbc3193895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-c967-77a8-a753-b33b321e0eb5.webp",
      "image_media": {
        "alt_text": "Open-concept living area with sofa, chairs, dining table, and a kitchen island.",
        "public_id": "019d20af-c967-77a8-a753-b33b321e0eb5",
        "storage_key": "property/6767906449165621/019d20af-c967-77a8-a753-b33b321e0eb5.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Open-plan apartment interior featuring a spacious living area, dining space, and modern kitchen for entertaining.",
      "link": "",
      "alt_text": "Open-concept living area with sofa, chairs, dining table, and a kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-3f50-75cb-8587-dda257b41651.webp"
    },
    {
      "id": "custom_d59e59b7-475f-4b66-b109-7f201c3dd6df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-cab7-7420-83d9-ed20fd8f4f78.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a tufted gray bed, orange bedding, two nightstands, and an open bathroom door.",
        "public_id": "019d20af-cab7-7420-83d9-ed20fd8f4f78",
        "storage_key": "property/6767906449165621/019d20af-cab7-7420-83d9-ed20fd8f4f78.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Bedroom in a modern apartment featuring a gray tufted bed with orange bedding, two nightstands, and an open bathroom door.",
      "link": "",
      "alt_text": "Cozy bedroom with a tufted gray bed, orange bedding, two nightstands, and an open bathroom door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-4b87-762c-bdb9-598057d0c630.webp"
    },
    {
      "id": "custom_3d429ab5-450d-4f78-9de2-14893a79d971",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-cc79-730f-ba1d-fa30702f0775.webp",
      "image_media": {
        "alt_text": "Apartment bathroom with a single vanity, large mirror, toilet, and a shower with a striped curtain.",
        "public_id": "019d20af-cc79-730f-ba1d-fa30702f0775",
        "storage_key": "property/6767906449165621/019d20af-cc79-730f-ba1d-fa30702f0775.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Interior view of an apartment bathroom featuring a wood vanity, large mirror, medicine cabinet, toilet, and a shower with a striped curtain.",
      "link": "",
      "alt_text": "Apartment bathroom with a single vanity, large mirror, toilet, and a shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-4c5d-7100-97f3-4f459bf67a3d.webp"
    },
    {
      "id": "custom_a1bd21da-bcb6-4cd4-81bc-39d9e8b2fcbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-cc76-775a-86c0-0a7dcfe3a33d.webp",
      "image_media": {
        "alt_text": "Aerial view of a downtown city skyline with tall buildings and streets at dusk.",
        "public_id": "019d20af-cc76-775a-86c0-0a7dcfe3a33d",
        "storage_key": "property/6767906449165621/019d20af-cc76-775a-86c0-0a7dcfe3a33d.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "Aerial view of a downtown skyline, highlighting the property’s urban location and nearby amenities.",
      "link": "",
      "alt_text": "Aerial view of a downtown city skyline with tall buildings and streets at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-5f90-73bc-8ff0-5d6a21a9fb6f.webp"
    },
    {
      "id": "custom_75cd9d7d-28a2-4dd9-ab39-5f61a32b3362",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-d352-73ce-a74b-6468cdca0673.webp",
      "image_media": {
        "alt_text": "Large white OKC letters on a grassy field with a Ferris wheel behind them.",
        "public_id": "019d20af-d352-73ce-a74b-6468cdca0673",
        "storage_key": "property/6767906449165621/019d20af-d352-73ce-a74b-6468cdca0673.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "Iconic OKC monument sign on a grassy field with a Ferris wheel and city skyline in the background.",
      "link": "",
      "alt_text": "Large white OKC letters on a grassy field with a Ferris wheel behind them.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-6a99-776f-b457-3367a30fb5ea.webp"
    },
    {
      "id": "custom_57059dab-63d7-47ac-bb45-13c9dcbcac09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d20af-d519-73ea-893d-adaceba7881f.webp",
      "image_media": {
        "alt_text": "Aerial cityscape at dusk with lit skyscrapers and a colorful sunset sky.",
        "public_id": "019d20af-d519-73ea-893d-adaceba7881f",
        "storage_key": "property/6767906449165621/019d20af-d519-73ea-893d-adaceba7881f.webp",
        "width": 2000,
        "height": 650
      },
      "title": "Lifestyle",
      "description": "Panoramic view of a bustling downtown skyline at sunset, suitable for exterior/property branding.",
      "link": "",
      "alt_text": "Aerial cityscape at dusk with lit skyscrapers and a colorful sunset sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165621/019cfb45-7c29-77dd-a170-fae63f0e0126.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6a4271b2-6730-4e37-bfdd-ab83a44d9b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual establishment with a patio for pit-smoked beef brisket, ribs, pulled pork and more.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and sausage, with sides of mac and cheese, baked beans, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-50f2-7298-beeb-240d7f97865c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-50f2-7298-beeb-240d7f97865c",
        "storage_key": "property/6767906449165621/019d2709-50f2-7298-beeb-240d7f97865c.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-888a-71eb-bce6-f2001dee9642",
        "storage_key": "property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_8ec5a62c-45ed-448d-88f7-ae74ca25b6a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "9401 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Casual eatery offering burgers and other American eats at a location overlooking Lake Hefner.",
      "poi_long_description": "People say this bar and grill offers delicious burgers, fish tacos, and wraps, and they highlight the sweet potato fries and cherry cocktail. They also like the beautiful lake views, especially at sunset, the live music, and the outdoor patio.\n\nOther reviews mention the noise level can be distracting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5153-701f-8d7f-6b21aac3494e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5153-701f-8d7f-6b21aac3494e",
        "storage_key": "property/6767906449165621/019d2709-5153-701f-8d7f-6b21aac3494e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13485773733165357309&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "louies-grill--bar",
      "poi_latitude": "35.5657821",
      "poi_longitude": "-97.5775183",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-751-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-88c8-72f8-8e51-cdbaf79cbeac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-88c8-72f8-8e51-cdbaf79cbeac",
        "storage_key": "property/6767906449165621/019d2709-88c8-72f8-8e51-cdbaf79cbeac.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSzs7gwbsocR_ViddsIXJ7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_5d177e06-2e16-4ae0-8725-86aabb96fab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "9404 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious dishes like the Meddys Main Plate, hummus bowl, and garlic chicken, with generous portions and fresh, flavorful ingredients. They highlight the reasonable prices, casual and modern atmosphere, and the availability of outdoor seating and live music. They also like the friendly and attentive staff, and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5175-749e-bb07-aea15b2fb216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5175-749e-bb07-aea15b2fb216",
        "storage_key": "property/6767906449165621/019d2709-5175-749e-bb07-aea15b2fb216.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.meddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733599644329479405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "35.56632889999999",
      "poi_longitude": "-97.5666625",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-546-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-888a-71eb-bce6-f2001dee9642",
        "storage_key": "property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS_1pD8bsocR7YyE6QFo9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_f28427b7-8801-4253-b396-cd8b40ad0eff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Oklahoma City Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "5833 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Buffet dining as well as an arcade, laser tag arena and go-karts for kids' parties and other fun days out.",
      "poi_long_description": "Visitors say this pizza restaurant offers a buffet with a variety of food, including pizza, hot dogs, tacos, chicken, and a salad bar, as well as fun attractions like go-karts and laser tag. They like the friendly and helpful staff, the clean facilities, and the great value for families, with many mentioning it's a popular spot for birthday parties.\n\nSome reviews mention the buffet can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5161-7089-8248-e5932cb08231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5161-7089-8248-e5932cb08231",
        "storage_key": "property/6767906449165621/019d2709-5161-7089-8248-e5932cb08231.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7640346941500558065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-incredible-pizza-company",
      "poi_latitude": "35.5504818",
      "poi_longitude": "-97.6162357",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-728-8360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-888a-71eb-bce6-f2001dee9642",
        "storage_key": "property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Sq7dMEsocR8QriIBD3B2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_cbb2b31c-f869-4a62-a509-3aae8eabc7b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Biglow's Burgers",
      "poi_type": "Restaurants",
      "poi_address": "12309 N Council Rd Suite 1, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Casual restaurant offering comfort food such as burgers, fries, and cobbler, plus beer and wine.",
      "poi_long_description": "People say this restaurant serves delicious burgers, cheeseburger eggrolls, and fried pickles. They highlight the generous portions, flavorful seasoning, and the inclusion of fries and a drink with the burger. They also like the friendly staff and the chill atmosphere with a pool table and TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-553e-736e-901f-abd173022350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-553e-736e-901f-abd173022350",
        "storage_key": "property/6767906449165621/019d2709-553e-736e-901f-abd173022350.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.biglows.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9700302104395232001&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "biglows-burgers",
      "poi_latitude": "35.5957966",
      "poi_longitude": "-97.6567197",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-367-7299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-888a-71eb-bce6-f2001dee9642",
        "storage_key": "property/6767906449165621/019d2709-888a-71eb-bce6-f2001dee9642.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1_hdcgDsocRAbNzml5lnoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cac3dd5a-832b-4c1c-8b0d-6bee4efbffae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Feria Latina Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "4909 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Latino grocery and food store featuring fresh produce and a bakery.",
      "poi_long_description": "People say this supermarket offers fresh produce and delicious bakery items. They also highlight the reasonable prices on marinated meats and the convenient on-site restaurant.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-56ac-72d6-875b-9a54aa0376cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-56ac-72d6-875b-9a54aa0376cc",
        "storage_key": "property/6767906449165621/019d2709-56ac-72d6-875b-9a54aa0376cc.webp",
        "width": 949,
        "height": 1265
      },
      "poi_business_url": "http://www.laferialatina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7639629429527723566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feria-latina-supermarket",
      "poi_latitude": "35.4938889",
      "poi_longitude": "-97.6113889",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-606-4004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-88bf-7034-87dc-f4f7ead1ebc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-88bf-7034-87dc-f4f7ead1ebc4",
        "storage_key": "property/6767906449165621/019d2709-88bf-7034-87dc-f4f7ead1ebc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6vpcQIQsocRLr6eWn1qBWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3cc174ee-71b9-4d66-b7f0-4e7246514c92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Fresh meat and produce alongside bulk bins, plus a deli counter.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, bulk items, and bagels. They also highlight the low prices, great deals, and savings, as well as the friendly and helpful staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-561b-765f-a946-6ded49c99c09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-561b-765f-a946-6ded49c99c09",
        "storage_key": "property/6767906449165621/019d2709-561b-765f-a946-6ded49c99c09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=888982261208729925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.512444",
      "poi_longitude": "-97.5798107",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-832-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-88bf-7034-87dc-f4f7ead1ebc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-88bf-7034-87dc-f4f7ead1ebc4",
        "storage_key": "property/6767906449165621/019d2709-88bf-7034-87dc-f4f7ead1ebc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCahmuZoasocRRUn4EqhMVgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4335f660-2993-49ba-95c3-5e5a2c0dee19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 NW 59th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Large hardware chain stocked with a wide selection of tools, lumber and building materials, plus appliances.",
      "poi_long_description": "People say this home improvement store usually has what they need. They also highlight the staff is friendly and helpful.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-565e-75fd-ac93-d5112d78b2a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-565e-75fd-ac93-d5112d78b2a5",
        "storage_key": "property/6767906449165621/019d2709-565e-75fd-ac93-d5112d78b2a5.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/N-Oklahoma-City/OK/Oklahoma-City/73112/3902?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8923094349114202389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.5313564",
      "poi_longitude": "-97.5691642",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-843-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-88b2-71c8-9a0a-3e4f5395c6f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-88b2-71c8-9a0a-3e4f5395c6f2",
        "storage_key": "property/6767906449165621/019d2709-88b2-71c8-9a0a-3e4f5395c6f2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGSHGIfYasocRFVk_sAgz1Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0d397f95-85a9-4fac-9ec3-c0993b386b31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "6100 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain selling books and magazines, plus toys and gifts.",
      "poi_long_description": "People say this bookstore offers a huge selection of books, puzzles, music, and toys, and has a Starbucks. They highlight the clean, organized, and quiet atmosphere, and the friendly and helpful staff. They also like the convenient parking and the train table in the kids' section.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5a85-70c1-af6f-d86364069b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5a85-70c1-af6f-d86364069b66",
        "storage_key": "property/6767906449165621/019d2709-5a85-70c1-af6f-d86364069b66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2694",
      "poi_directions_map_url": "https://maps.google.com/?cid=986591179468385464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "35.5331139",
      "poi_longitude": "-97.5647667",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-843-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-88b2-71c8-9a0a-3e4f5395c6f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-88b2-71c8-9a0a-3e4f5395c6f2",
        "storage_key": "property/6767906449165621/019d2709-88b2-71c8-9a0a-3e4f5395c6f2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvczS4lgasocRuCy_VnMTsQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_550ba2cc-7eb5-4964-8acf-fdeaac87629c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6410 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Casual grocery chain selling organic, gluten-free and vegan foods, plus produce and packaged goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, organic foods, and healthy options. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5b6a-738f-8e42-f28323243488.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5b6a-738f-8e42-f28323243488",
        "storage_key": "property/6767906449165621/019d2709-5b6a-738f-8e42-f28323243488.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/oklahoma-city/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265666738450826751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.5374999",
      "poi_longitude": "-97.5647576",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-879-9989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-88bf-7034-87dc-f4f7ead1ebc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-88bf-7034-87dc-f4f7ead1ebc4",
        "storage_key": "property/6767906449165621/019d2709-88bf-7034-87dc-f4f7ead1ebc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSbEc1casocR_4XbhASL2tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e894ca7b-ff8e-41c2-adac-c55646fef1c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5b6c-75f4-b9cf-827d2abb024f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5b6c-75f4-b9cf-827d2abb024f",
        "storage_key": "property/6767906449165621/019d2709-5b6c-75f4-b9cf-827d2abb024f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb2-729f-9ae8-52097e909f01",
        "storage_key": "property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e80a978a-fa1f-42f0-bc9b-0c5d20b34519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5bcc-72cd-9b0d-445d7b2162cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5bcc-72cd-9b0d-445d7b2162cb",
        "storage_key": "property/6767906449165621/019d2709-5bcc-72cd-9b0d-445d7b2162cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb2-729f-9ae8-52097e909f01",
        "storage_key": "property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_f80a1f2a-327f-4dca-b102-4c17ff1b21e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Bethany Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "6700 NW 35th St, Bethany, OK 73008, USA",
      "poi_short_description": "Public library offering kid-friendly activities, meeting rooms, and other resources.",
      "poi_long_description": "People say this public library offers a diverse selection of books and a variety of activities for all ages. They highlight the cozy atmosphere and the availability of meeting rooms. They also like the helpful and attentive staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-5fe6-7228-a720-f90b74314e1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5fe6-7228-a720-f90b74314e1f",
        "storage_key": "property/6767906449165621/019d2709-5fe6-7228-a720-f90b74314e1f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15531442417609680617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-library---metropolitan-library-system",
      "poi_latitude": "35.5062789",
      "poi_longitude": "-97.6316452",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-789-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb2-729f-9ae8-52097e909f01",
        "storage_key": "property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV4NBRVwFsocR6SYP95bEitc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_00dfc093-0a34-4a3b-852e-26445695e791",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Southwestern Christian University",
      "poi_type": "Education",
      "poi_address": "7210 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-60e0-7402-9b44-d4454702cf4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-60e0-7402-9b44-d4454702cf4c",
        "storage_key": "property/6767906449165621/019d2709-60e0-7402-9b44-d4454702cf4c.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.swcu.edu",
      "poi_directions_map_url": "https://maps.google.com/?cid=6939619905505591377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwestern-christian-university",
      "poi_latitude": "35.5120221",
      "poi_longitude": "-97.6398185",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-789-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb2-729f-9ae8-52097e909f01",
        "storage_key": "property/6767906449165621/019d2709-8cb2-729f-9ae8-52097e909f01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAzjOyG4FsocRUQDkT4l7TmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f09134ff-1437-4182-a37f-5ba0defdb892",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6079-70b7-94c2-458a55c83919.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6079-70b7-94c2-458a55c83919",
        "storage_key": "property/6767906449165621/019d2709-6079-70b7-94c2-458a55c83919.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210386",
      "poi_longitude": "-97.661832",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb1-7168-b739-6ca9fe562f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb1-7168-b739-6ca9fe562f63",
        "storage_key": "property/6767906449165621/019d2709-8cb1-7168-b739-6ca9fe562f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_012b8a66-d374-4771-812e-d2b481ab76e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Lake Overholser Iron Bridge",
      "poi_type": "Entertainment",
      "poi_address": "8703-8709 Overholser Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Historic bridge on the former Route 66, still open to traffic, with scenic views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6142-71ed-8f72-9e2ac9f0c3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6142-71ed-8f72-9e2ac9f0c3e9",
        "storage_key": "property/6767906449165621/019d2709-6142-71ed-8f72-9e2ac9f0c3e9.webp",
        "width": 720,
        "height": 491
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1592759798430792050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-overholser-iron-bridge",
      "poi_latitude": "35.5146149",
      "poi_longitude": "-97.6638523",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQwMnJkFsocRcnn9DZmeGhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_80fe3e4f-3219-4877-a995-de915a769637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Oklahoma Museum of Flying",
      "poi_type": "Entertainment",
      "poi_address": "7110 Millionaire Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Volunteer-powered locale for seeing and touching real planes plus learning about their history and mechanics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6420-772b-8e3b-a6f34849b00a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6420-772b-8e3b-a6f34849b00a",
        "storage_key": "property/6767906449165621/019d2709-6420-772b-8e3b-a6f34849b00a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/oklahomamuseumofflying/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234880537762503548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-museum-of-flying",
      "poi_latitude": "35.5337967",
      "poi_longitude": "-97.6380221",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8c8e-77f9-901a-01ade6790fc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8c8e-77f9-901a-01ade6790fc7",
        "storage_key": "property/6767906449165621/019d2709-8c8e-77f9-901a-01ade6790fc7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c3VjhkFsocRfJu4XYR1Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_91f1db97-7da5-4f75-8f3d-569864865ea1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Pirate Stadium",
      "poi_type": "Entertainment",
      "poi_address": "5300 NW 50th St, Oklahoma City, OK 73122, USA",
      "poi_short_description": "Venue used for graduation, track meets, and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-65a8-738a-9205-7592dcc47c79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-65a8-738a-9205-7592dcc47c79",
        "storage_key": "property/6767906449165621/019d2709-65a8-738a-9205-7592dcc47c79.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://stadiumconnection.com/ok/stadium.php?id=2852",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523176646670315445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pirate-stadium",
      "poi_latitude": "35.5216132",
      "poi_longitude": "-97.6066534",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-789-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb1-7168-b739-6ca9fe562f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb1-7168-b739-6ca9fe562f63",
        "storage_key": "property/6767906449165621/019d2709-8cb1-7168-b739-6ca9fe562f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR1OWhrUasocRtW_clBuM6p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_39884193-00d9-42b4-8489-500512f4fee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Herrick Building and Auditorium - SNU",
      "poi_type": "Entertainment",
      "poi_address": "6749 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6507-753f-a72b-e14ea6199cc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6507-753f-a72b-e14ea6199cc2",
        "storage_key": "property/6767906449165621/019d2709-6507-753f-a72b-e14ea6199cc2.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15681811452994641819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herrick-building-and-auditorium---snu",
      "poi_latitude": "35.5123354",
      "poi_longitude": "-97.6304674",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dCV-0IFsocRm99lQm78oNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_94febf11-8317-4b79-9c98-79fd68e3c157",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-661f-7311-a79d-7239a6281f3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-661f-7311-a79d-7239a6281f3f",
        "storage_key": "property/6767906449165621/019d2709-661f-7311-a79d-7239a6281f3f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6a64de55-9912-480a-baae-265ed594db02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Neel Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N MacArthur Blvd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-699e-724d-bf27-7e36f9fbe927.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-699e-724d-bf27-7e36f9fbe927",
        "storage_key": "property/6767906449165621/019d2709-699e-724d-bf27-7e36f9fbe927.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neel.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132737864806100553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neel-veterinary-hospital",
      "poi_latitude": "35.4972708",
      "poi_longitude": "-97.6183664",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-947-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYV66BPkPsocRSe6SHTFvWjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_21f05670-59ea-4302-a2d3-c85cfb0ace51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4202 Northwest Expy, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Chain gym offering free high-school memberships, plus tanning beds, massage chairs, and TVs.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and workout options, including tanning beds and massage chairs. They also highlight the clean facilities, spacious layout, and convenient location.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-69b7-74a6-80c3-1fe5988ddcd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-69b7-74a6-80c3-1fe5988ddcd0",
        "storage_key": "property/6767906449165621/019d2709-69b7-74a6-80c3-1fe5988ddcd0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-nw-expressway-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17337479712866526724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5386202",
      "poi_longitude": "-97.5960525",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-242-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWPVatwasocRBGbz4fAZm_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_48b18079-0a46-488c-882e-76862bf56c44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Crunch Fitness - OKC Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "8490 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, weight machines, and tanning beds, and provides childcare services.\n\nOther reviews mention the music can be loud and the cancellation policy can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6b02-76e8-aeda-6032f77d6dc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6b02-76e8-aeda-6032f77d6dc6",
        "storage_key": "property/6767906449165621/019d2709-6b02-76e8-aeda-6032f77d6dc6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/okc-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916258324870179385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---okc-northwest",
      "poi_latitude": "35.56632099999999",
      "poi_longitude": "-97.6628647",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-267-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWtxzOQFsocROaq5dE18-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ec818b2c-7a85-48ad-a15a-c94ba36b89a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Colaw Fitness of Oklahoma City Gyms",
      "poi_type": "Health and Wellness",
      "poi_address": "3645 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Positive gym, with exercise equipment, tanning beds and massage chairs – plus spiritual wellness.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, tanning beds, and massage chairs. They highlight the affordable membership options, clean facilities, and welcoming atmosphere. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6a68-7054-a1a2-353384b0e0cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6a68-7054-a1a2-353384b0e0cc",
        "storage_key": "property/6767906449165621/019d2709-6a68-7054-a1a2-353384b0e0cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colawfitness.com/gyms/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355987367554066829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colaw-fitness-of-oklahoma-city-gyms",
      "poi_latitude": "35.5128276",
      "poi_longitude": "-97.5823903",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-838-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0nvVDcbsocRjSm2Jj1u9nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_80ab036f-6081-4a0f-bbb1-6da4722f54f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6e41-7476-b64c-6bb367a7779f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6e41-7476-b64c-6bb367a7779f",
        "storage_key": "property/6767906449165621/019d2709-6e41-7476-b64c-6bb367a7779f.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a5997865-6fba-4105-8e5d-69227d662f0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Bethany YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "Chain fitness center offering amenities such as a pool, basketball courts, and water aerobics classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6f72-71c8-bd8b-17c918ebef15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6f72-71c8-bd8b-17c918ebef15",
        "storage_key": "property/6767906449165621/019d2709-6f72-71c8-bd8b-17c918ebef15.webp",
        "width": 994,
        "height": 533
      },
      "poi_business_url": "https://ymcaokc.org/branches/bethany/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8306823524238509196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-ymca",
      "poi_latitude": "35.5051032",
      "poi_longitude": "-97.6316419",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-789-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wBj710FsocRjEQY3vvDR3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4c928e83-56a5-4441-bcfc-77208c4451e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Four Star Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "7013 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Spacious gym featuring weights and cardio equipment, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including dumbbells over 120lbs, Hammer Strength, and Atlantis equipment. They highlight the clean facilities and friendly, helpful staff. They also like the serious and respectful workout environment. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6f79-740e-8629-f6d7b74b0828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6f79-740e-8629-f6d7b74b0828",
        "storage_key": "property/6767906449165621/019d2709-6f79-740e-8629-f6d7b74b0828.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050931711802974728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---oklahoma-city",
      "poi_latitude": "35.54217879999999",
      "poi_longitude": "-97.5664473",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-418-4496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6JthFYasocRCKJ1Ww0Uoew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5620e250-48c0-45bb-b2c4-e49d50545d3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Rockwell Plaza YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8300 Glade Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Clean gym with a basketball court.",
      "poi_long_description": "People say this gym offers a pool and a variety of fitness equipment.\n\nOther reviews mention the staff can be unhelpful and the rules can be strict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-6f8b-701d-acde-dd62e0aca99f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6f8b-701d-acde-dd62e0aca99f",
        "storage_key": "property/6767906449165621/019d2709-6f8b-701d-acde-dd62e0aca99f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/rockwell-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17719347020841965419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockwell-plaza-ymca",
      "poi_latitude": "35.5546582",
      "poi_longitude": "-97.6422942",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-621-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJleKdJ_AEsocRa1cp_TvE5_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4d58c116-e62d-48c8-abff-8c0fe6861cda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-738c-7694-bac5-baf2235e5aed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-738c-7694-bac5-baf2235e5aed",
        "storage_key": "property/6767906449165621/019d2709-738c-7694-bac5-baf2235e5aed.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9089-70a8-b0d3-08b5a71d82fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9089-70a8-b0d3-08b5a71d82fa",
        "storage_key": "property/6767906449165621/019d2709-9089-70a8-b0d3-08b5a71d82fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cb35e84c-cc50-498c-8229-dc3c19185078",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-7434-71fe-ae25-b3a8318c02ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7434-71fe-ae25-b3a8318c02ef",
        "storage_key": "property/6767906449165621/019d2709-7434-71fe-ae25-b3a8318c02ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9089-70a8-b0d3-08b5a71d82fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9089-70a8-b0d3-08b5a71d82fa",
        "storage_key": "property/6767906449165621/019d2709-9089-70a8-b0d3-08b5a71d82fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9d95d1c3-b634-4f2b-a9b1-5b889ecb4185",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-74ad-77d0-a470-09bf1a25c70f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-74ad-77d0-a470-09bf1a25c70f",
        "storage_key": "property/6767906449165621/019d2709-74ad-77d0-a470-09bf1a25c70f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9161-77ab-9ad9-89d511865f0a",
        "storage_key": "property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b7ff4ad0-9eb4-4252-a571-9ff1089b5ad6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-76ac-775b-bc47-d0abdc3433c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-76ac-775b-bc47-d0abdc3433c8",
        "storage_key": "property/6767906449165621/019d2709-76ac-775b-bc47-d0abdc3433c8.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9161-77ab-9ad9-89d511865f0a",
        "storage_key": "property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3d1e4982-9cc2-4b2e-bde2-81023c7dcaa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-7897-730d-beb9-66c338135f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7897-730d-beb9-66c338135f9d",
        "storage_key": "property/6767906449165621/019d2709-7897-730d-beb9-66c338135f9d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9161-77ab-9ad9-89d511865f0a",
        "storage_key": "property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_afc238ef-6042-42c2-b025-a1f73ee6c6aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Dolese Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5105 NW 50th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Park with picnic tables, a playground, a paved cycling trail, disc golf course, and facilities for baseball and fishing.",
      "poi_long_description": "People say this park offers a disc golf course, trails, a playground, and a pond for fishing. They highlight the beautiful scenery, the well-maintained trails, and the friendly people. They also like the calming atmosphere and the ample space for various activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-791b-719e-b3b8-f02cd6cf7127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-791b-719e-b3b8-f02cd6cf7127",
        "storage_key": "property/6767906449165621/019d2709-791b-719e-b3b8-f02cd6cf7127.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15736370327146326173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dolese-park",
      "poi_latitude": "35.52624369999999",
      "poi_longitude": "-97.6055628",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9161-77ab-9ad9-89d511865f0a",
        "storage_key": "property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9-e8kasocRneiNC3DRYto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_715d6a42-e03f-4f67-ae69-9ba144445fc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Route 66 Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9901 NW 23rd St, Yukon, OK 73099, USA",
      "poi_short_description": "148 acres of ponds, trails & an observation tower with lake views, plus a Mother Road memorial.",
      "poi_long_description": "People say this park offers a great walking path, access to fishing, and a playground. They highlight the relaxing vibe, family-friendly atmosphere, and clean environment. They also like the long walkways and the scenic lake with ducks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-7a4e-7709-a9e1-186e1e9031cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7a4e-7709-a9e1-186e1e9031cc",
        "storage_key": "property/6767906449165621/019d2709-7a4e-7709-a9e1-186e1e9031cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/32/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=90707035350423985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "route-66-park",
      "poi_latitude": "35.4969132",
      "poi_longitude": "-97.6934847",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9161-77ab-9ad9-89d511865f0a",
        "storage_key": "property/6767906449165621/019d2709-9161-77ab-9ad9-89d511865f0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YR1wPgFsocRsdmwbJFBQgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fc79bd96-9dd7-4618-be11-09b363674350",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Wiley Post Airport-PWA",
      "poi_type": "Transportation & Transit",
      "poi_address": "5915 Philip J Rhoads Ave, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-7b79-7068-ad1e-c6c9f2b3fb87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7b79-7068-ad1e-c6c9f2b3fb87",
        "storage_key": "property/6767906449165621/019d2709-7b79-7068-ad1e-c6c9f2b3fb87.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://www.wileypostairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17919166834402155680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wiley-post-airport-pwa",
      "poi_latitude": "35.5307445",
      "poi_longitude": "-97.6430208",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9089-70a8-b0d3-0dabc86cee3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9089-70a8-b0d3-0dabc86cee3d",
        "storage_key": "property/6767906449165621/019d2709-9089-70a8-b0d3-0dabc86cee3d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0-vGAMFsocRoFyAy0urrfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ad8adbea-38a4-4a8a-86f4-63acb5fa1578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Sundance Airport KHSD",
      "poi_type": "Transportation & Transit",
      "poi_address": "13000 N Sara Rd, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-7d94-767b-b533-3bbbc4bd5380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7d94-767b-b533-3bbbc4bd5380",
        "storage_key": "property/6767906449165621/019d2709-7d94-767b-b533-3bbbc4bd5380.webp",
        "width": 1280,
        "height": 478
      },
      "poi_business_url": "http://sundanceairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335938299321620831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sundance-airport-khsd",
      "poi_latitude": "35.601503",
      "poi_longitude": "-97.7069306",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-373-3886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9089-70a8-b0d3-0dabc86cee3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9089-70a8-b0d3-0dabc86cee3d",
        "storage_key": "property/6767906449165621/019d2709-9089-70a8-b0d3-0dabc86cee3d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eH4NUUBsocRX5nnHM40ihI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_be131e18-7adc-4cbe-a72c-7778cd03c2f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Jetset FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "7220 NW 63rd St, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-7d9d-745c-921f-cb59819603e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7d9d-745c-921f-cb59819603e4",
        "storage_key": "property/6767906449165621/019d2709-7d9d-745c-921f-cb59819603e4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jetsetfbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=522519284200811341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jetset-fbo",
      "poi_latitude": "35.5368188",
      "poi_longitude": "-97.6412624",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-888-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-9089-70a8-b0d3-0dabc86cee3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9089-70a8-b0d3-0dabc86cee3d",
        "storage_key": "property/6767906449165621/019d2709-9089-70a8-b0d3-0dabc86cee3d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1b0wrcFsocRTasUQ4VcQAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7854a485-78af-45bf-bdb6-208f4f135e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-7f93-75c8-a292-86372b79596d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7f93-75c8-a292-86372b79596d",
        "storage_key": "property/6767906449165621/019d2709-7f93-75c8-a292-86372b79596d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_367302ec-96e9-4d8e-b832-39dc1af285a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-814e-7025-bd35-238322896452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-814e-7025-bd35-238322896452",
        "storage_key": "property/6767906449165621/019d2709-814e-7025-bd35-238322896452.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0ec8f375-7d8f-4ff7-9597-f44c297c6a63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Express Employment International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9701 Boardwalk Blvd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8392-72c3-ab93-3126624f73dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8392-72c3-ab93-3126624f73dc",
        "storage_key": "property/6767906449165621/019d2709-8392-72c3-ab93-3126624f73dc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.expresspros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=92586903052956857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "express-employment-international",
      "poi_latitude": "35.56707",
      "poi_longitude": "-97.666693",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-840-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6z8UW8EsocRuTRTO0zvSAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_def59056-dc1e-430f-8cda-2e027e61a907",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-82b6-741c-9756-5857bf01a28e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-82b6-741c-9756-5857bf01a28e",
        "storage_key": "property/6767906449165621/019d2709-82b6-741c-9756-5857bf01a28e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_53b79047-c241-45c3-9334-e25dbddade39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Pacebutler Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5915 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8418-7599-ab55-5258b0100b8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8418-7599-ab55-5258b0100b8d",
        "storage_key": "property/6767906449165621/019d2709-8418-7599-ab55-5258b0100b8d.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "http://www.pacebutler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8557959088291269970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacebutler-corporation",
      "poi_latitude": "35.4936498",
      "poi_longitude": "-97.6204189",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-755-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8cb8-7603-a160-473ada2c642c",
        "storage_key": "property/6767906449165621/019d2709-8cb8-7603-a160-473ada2c642c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZOm26MesocRUk3t43L6w3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e9f2b56c-cf7c-48c3-ae47-79020e97704f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Harvest Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "8201 NW 104th St, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-c663-71e5-af3d-62ffb0a042d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c663-71e5-af3d-62ffb0a042d3",
        "storage_key": "property/6767906449165621/019d7912-c663-71e5-af3d-62ffb0a042d3.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://harvesthills.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14172348023960517067&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harvest-hills-elementary-school",
      "poi_latitude": "35.57638439999999",
      "poi_longitude": "-97.6603915",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-721-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b91b-7089-8b06-7610fbc2b1a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b91b-7089-8b06-7610fbc2b1a0",
        "storage_key": "property/6767906449165621/019cfb45-b91b-7089-8b06-7610fbc2b1a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfzcsf3sEsocRyzlggXBLrsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4d6ca8df-d171-42e9-85dc-7650dfb8681c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Putnam City North High School",
      "poi_type": "Education",
      "poi_address": "11800 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-c526-7642-bde8-dd4ed3d1f1e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c526-7642-bde8-dd4ed3d1f1e5",
        "storage_key": "property/6767906449165621/019d7912-c526-7642-bde8-dd4ed3d1f1e5.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://pcnorth.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10895318835090211107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "putnam-city-north-high-school",
      "poi_latitude": "35.5891349",
      "poi_longitude": "-97.6368418",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-722-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b91b-7089-8b06-7610fbc2b1a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b91b-7089-8b06-7610fbc2b1a0",
        "storage_key": "property/6767906449165621/019cfb45-b91b-7089-8b06-7610fbc2b1a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZkjjmADsocRI8EsMMHyM5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_11c68d98-d6ae-4c71-8541-8a3a6a8f8a4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Vast",
      "poi_type": "Restaurants",
      "poi_address": "333 W Sheridan Ave 49th Floor, Oklahoma City, OK 73102, USA",
      "poi_short_description": "New American fine dining & cocktails on the 49th floor, with private rooms & event space available.",
      "poi_long_description": "People say this American restaurant offers a delicious lunch buffet with a rotating menu, featuring options like shrimp and poblano grits, and a dessert bar with creme brulee. They highlight the incredible views of the city from the 49th floor, the elegant and welcoming atmosphere, and the professional and attentive service. They also like the great value of the lunch buffet and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-c729-746b-ae07-35ea3115ff65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c729-746b-ae07-35ea3115ff65",
        "storage_key": "property/6767906449165621/019d7912-c729-746b-ae07-35ea3115ff65.webp",
        "width": 1280,
        "height": 942
      },
      "poi_business_url": "http://www.vastokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17764016300641992691&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vast",
      "poi_latitude": "35.4669456",
      "poi_longitude": "-97.517715",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-702-7262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4701124d90f9",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1qdbykXsocR878DKLV2hvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ca473046-375c-4dac-b11d-4a07d850e6a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Melting Pot",
      "poi_type": "Restaurants",
      "poi_address": "4 E Sheridan Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Fondue restaurant chain offering heated pots of cheese, chocolate or broth for dipping & cooking.",
      "poi_long_description": "People say this fondue restaurant offers delicious cheese, salad, and chocolate fondue, as well as a variety of meats and seafood. They highlight the fun and interactive dining experience, and the cozy, intimate atmosphere, perfect for special occasions. They also like the attentive and knowledgeable service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-c4d1-7488-a47a-87e52fbbda4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c4d1-7488-a47a-87e52fbbda4e",
        "storage_key": "property/6767906449165621/019d7912-c4d1-7488-a47a-87e52fbbda4e.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.meltingpot.com/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14929088845263865912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "melting-pot",
      "poi_latitude": "35.4661593",
      "poi_longitude": "-97.5118221",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4701124d90f9",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfp6UiYXsocROAgzAjXHLs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fondue_restaurant"
    },
    {
      "id": "custom_f73f7045-3600-42fc-8ee0-5b6fbeba8d46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "McClintock Saloon & Chop House",
      "poi_type": "Restaurants",
      "poi_address": "2227 Exchange Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Relaxed spot serving steaks, burgers and prime rib alongside cocktails.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, burgers, and chicken fried steak. They also highlight the great atmosphere, with wood and velvet booths, chandeliers, and carvings, and the exceptional whiskey menu.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-cda2-724f-9e2f-42c8776b065f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cda2-724f-9e2f-42c8776b065f",
        "storage_key": "property/6767906449165621/019d7912-cda2-724f-9e2f-42c8776b065f.webp",
        "width": 538,
        "height": 304
      },
      "poi_business_url": "http://mcclintocksaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17151538246475803024&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcclintock-saloon-chop-house",
      "poi_latitude": "35.4530152",
      "poi_longitude": "-97.5542409",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-232-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4701124d90f9",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwT-qxsRsocRkGm3lCmBBu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4ba59276-a62c-4862-8af7-07d825a6ce04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Cajun Corner - Council OKC",
      "poi_type": "Restaurants",
      "poi_address": "9200 N Council Rd ste a, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Counter-serve locale dishing up Cajun specialties such as po' boys and blackened fish, plus beer.",
      "poi_long_description": "People say this Cajun restaurant serves delicious loaded blackened fish, chicken wings, and etouffee. They highlight the generous portions, reasonable prices, and fast service. They also like the friendly staff and comfortable dining experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-cfe7-7430-bb0b-7c806f06b69c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cfe7-7430-bb0b-7c806f06b69c",
        "storage_key": "property/6767906449165621/019d7912-cfe7-7430-bb0b-7c806f06b69c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cajuncornerokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=175148386921407426&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cajun-corner-council-okc",
      "poi_latitude": "35.5641783",
      "poi_longitude": "-97.6556592",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-792-2588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4701124d90f9",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLybUFmAEsocRwuNuqYdAbgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_da992057-1249-4b7b-b79e-8927caba5f1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "S&B’s Burger Joint - NW Expressway",
      "poi_type": "Restaurants",
      "poi_address": "7640 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Casual eatery featuring classic burgers and sliders, spiked milkshakes and a full bar.",
      "poi_long_description": "People say this restaurant serves great burgers, fries, and onion rings. They also highlight the reasonable prices, fun atmosphere with TVs and games, and friendly service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-d356-7758-b91c-91d9b4eaae4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d356-7758-b91c-91d9b4eaae4f",
        "storage_key": "property/6767906449165621/019d7912-d356-7758-b91c-91d9b4eaae4f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sandbburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=163980142975027608&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "s-b-s-burger-joint-nw-expressway",
      "poi_latitude": "35.5621996",
      "poi_longitude": "-97.649037",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-603-8116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4701124d90f9",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfYLZYfMEsocRmIk-PBKTRgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e38a1a4b-db02-4442-a77c-84545072d3ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "8315 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-da2e-7494-a2b1-6c4d60714c6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-da2e-7494-a2b1-6c4d60714c6a",
        "storage_key": "property/6767906449165621/019d7912-da2e-7494-a2b1-6c4d60714c6a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/12808",
      "poi_directions_map_url": "https://maps.google.com/?cid=3275952508498585922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.55584",
      "poi_longitude": "-97.63958",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-506-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-4ae7-77e3-9be0-d5fad9a9eb42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-4ae7-77e3-9be0-d5fad9a9eb42",
        "storage_key": "property/6767906449165621/019d7913-4ae7-77e3-9be0-d5fad9a9eb42.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtfrQIO8EsocRQqkbInOFdi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_ce421468-16f8-4bc2-b287-0b94e8580b8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Cal's Chicago Style Eatery",
      "poi_type": "Restaurants",
      "poi_address": "7005 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Petite restaurant featuring Chicago-style hot dogs, pizzas and sandwiches.",
      "poi_long_description": "People say this restaurant serves delicious Italian beef sandwiches, Chicago dogs, and gyros. They highlight the fresh ingredients, tender beef, and flavorful au jus. They also like the friendly staff and the authentic Chicago-style decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-db3b-7202-8c2d-a13c8d133084.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-db3b-7202-8c2d-a13c8d133084",
        "storage_key": "property/6767906449165621/019d7912-db3b-7202-8c2d-a13c8d133084.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.calschicagoeateryokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13586519042517171839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cal-s-chicago-style-eatery",
      "poi_latitude": "35.5595564",
      "poi_longitude": "-97.6380766",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-730-6063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4701124d90f9",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT3AnJsEsocRf_5QrxUDjbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a75be07c-3b39-4f0b-89e7-6d8207acc2a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "8116 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "Some people say this fast food restaurant has friendly carhops.\n\nOther reviews mention the service can be slow and portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-e5b7-763d-aa1e-ec4ff7681ed2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e5b7-763d-aa1e-ec4ff7681ed2",
        "storage_key": "property/6767906449165621/019d7912-e5b7-763d-aa1e-ec4ff7681ed2.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/ok/oklahoma-city/8116-n-w--expressway/store-2684?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg0ODE3NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17838639289040973925&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "35.5664628",
      "poi_longitude": "-97.6591193",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-722-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4701124d90f9",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4701124d90f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUVwSR2EEsocRZTCdk-uTj_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_cfd4fdb1-22d5-4412-8443-036f2a964734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Penn Square Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1901 Northwest Expy, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Classic enclosed mall with department stores, services & a food court, plus ample parking.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, specialty shops, and dining choices. They also highlight the fun and laid-back atmosphere, and the clean and well-maintained facilities.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-ef32-719e-8cfd-a94aede7c80c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ef32-719e-8cfd-a94aede7c80c",
        "storage_key": "property/6767906449165621/019d7912-ef32-719e-8cfd-a94aede7c80c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/penn-square-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811350003534984838&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "penn-square-mall",
      "poi_latitude": "35.5249271",
      "poi_longitude": "-97.5441961",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-842-4424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqd3wbBUasocRhvb-2-7rAyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e133d860-5bc1-4ba4-be86-b9aaf6b99509",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "AMC West End Pointe 8",
      "poi_type": "Shopping & Retail",
      "poi_address": "12825 NW 10th St, Yukon, OK 73099, USA",
      "poi_short_description": "First-run movie theater featuring digital surround sound, 3D screens & stadium seating.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats and a wide selection of movies. They also highlight the friendly and helpful staff, and the clean restrooms and auditoriums.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-ef5c-7315-b77d-c73678c3549a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ef5c-7315-b77d-c73678c3549a",
        "storage_key": "property/6767906449165621/019d7912-ef5c-7315-b77d-c73678c3549a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/oklahoma-city/amc-west-end-pointe-8?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1705625619343007816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-west-end-pointe-8",
      "poi_latitude": "35.4795244",
      "poi_longitude": "-97.7549866",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-354-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-4ae8-70a3-b16b-e3206b965a94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-4ae8-70a3-b16b-e3206b965a94",
        "storage_key": "property/6767906449165621/019d7913-4ae8-70a3-b16b-e3206b965a94.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJOc76Rm4IsocRSOC-yHaZqxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_c2540926-0b1e-42cb-bc01-66e492987c22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Chisholm Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1150 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Shopping mall featuring a mix of stores, including a grocery, movie theater, and a gym.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including Harbor Freight, Langston Western Wear, and Sprouts. They also highlight the clean and well-organized stores, and the friendly, helpful, and energetic staff.\n\nOther reviews mention some items can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-f9d5-762f-89ee-fc8702d26c56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f9d5-762f-89ee-fc8702d26c56",
        "storage_key": "property/6767906449165621/019d7912-f9d5-762f-89ee-fc8702d26c56.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://amzn.to/40Rli7Y",
      "poi_directions_map_url": "https://maps.google.com/?cid=8983776208824273075&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chisholm-shopping-center",
      "poi_latitude": "35.4914395",
      "poi_longitude": "-97.7591107",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVLG-XUIsocRs4iTJN3IrHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6d7db9c2-3ccc-4d44-a159-6331f5e87b4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "7012 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-f9fa-729f-ba70-93d033e1b8c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f9fa-729f-ba70-93d033e1b8c8",
        "storage_key": "property/6767906449165621/019d7912-f9fa-729f-ba70-93d033e1b8c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/69",
      "poi_directions_map_url": "https://maps.google.com/?cid=11413526958338316434&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "35.55556",
      "poi_longitude": "-97.637451",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-721-9672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN2SCSOkEsocRkpgZEkz-ZJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_a61d0a9f-2a1b-4b00-baa3-94d9c6603a36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Garden Center at The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7620 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-fa90-71ee-9e6a-01ecb37c505d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fa90-71ee-9e6a-01ecb37c505d",
        "storage_key": "property/6767906449165621/019d7912-fa90-71ee-9e6a-01ecb37c505d.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "https://www.homedepot.com/l/NW-Oklahoma-City/OK/Oklahoma-City/73132/3909/garden-center?emt=GCGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8963018846873871714&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garden-center-at-the-home-depot",
      "poi_latitude": "35.5611024",
      "poi_longitude": "-97.6480411",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-773-6077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV3yZofMEsocRYmUMMycKY3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden_center"
    },
    {
      "id": "custom_f9dea70b-34ea-44e7-8a89-2045c700ea57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9001 NW Psge, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, accessories, and seasonal items, and they like the Sephora inside. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the Amazon returns can close earlier than the rest of the store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7912-fca2-7328-b5e1-c8e976aa3e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fca2-7328-b5e1-c8e976aa3e23",
        "storage_key": "property/6767906449165621/019d7912-fca2-7328-b5e1-c8e976aa3e23.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/oklahomacity-488.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701744966133765203&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "35.5616271",
      "poi_longitude": "-97.651654",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-621-1779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgzVq5vQEsocRU1RmpXNgJr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6d7a1373-f084-45fc-99a6-8b3454ce68da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Southern Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1606 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Clean retail complex featuring a variety of shops, as well as a few restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-0185-732d-a5c5-af800183102a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0185-732d-a5c5-af800183102a",
        "storage_key": "property/6767906449165621/019d7913-0185-732d-a5c5-af800183102a.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/3FyyOGj",
      "poi_directions_map_url": "https://maps.google.com/?cid=10840290695010069954&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "southern-hills-shopping-center",
      "poi_latitude": "35.3902295",
      "poi_longitude": "-97.5458708",
      "poi_miles_from_property": "16.9 mi",
      "poi_walking_minutes": "6 hours 17 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-515-7192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEfETBZYTsocRwi0M6vNycJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a22e7bd6-ebc0-42c7-8818-5f94647665dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7800 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Department store offering clothing, toys, and other goods, plus a grocery and a pharmacy.",
      "poi_long_description": "People say this department store offers a wide variety of merchandise and is easy to navigate.\n\nOther reviews mention the service can be unhelpful and the prices can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-0151-744f-a87b-61883dfa602c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0151-744f-a87b-61883dfa602c",
        "storage_key": "property/6767906449165621/019d7913-0151-744f-a87b-61883dfa602c.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/622-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=72616393302217797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.5623547",
      "poi_longitude": "-97.6540121",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-773-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ3LN2ooEsocRRRSmlzn8AQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_db4d83fd-cba7-4efc-a8bf-be00a660ecb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "OKC Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7624 W Reno Ave Suite 380, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Relaxed outdoor mall featuring more than 70 brand-name designer stores of shoes, clothing and more.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores and good deals, especially during sales. They also highlight the clean and well-maintained facilities, and the friendly and helpful service.\n\nOther reviews mention the food court can have limited options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-0510-75f5-abd8-d6cff83d5086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0510-75f5-abd8-d6cff83d5086",
        "storage_key": "property/6767906449165621/019d7913-0510-75f5-abd8-d6cff83d5086.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.okcoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773095145334850603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "okc-outlets",
      "poi_latitude": "35.4625898",
      "poi_longitude": "-97.6473972",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-787-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-4d3d8a239d0f",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-4d3d8a239d0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWyLw68PsocRK0Sn8qNMmxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9feb91da-0f0d-4b0a-8518-d50fcc4d6f57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11101 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Grocery store offering an assortment of items including baby gear and home furniture, plus a pharmacy.",
      "poi_long_description": "People say this grocery store offers a wide variety of products and has friendly staff.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-04b5-7707-8e49-ddac52daa62f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-04b5-7707-8e49-ddac52daa62f",
        "storage_key": "property/6767906449165621/019d7913-04b5-7707-8e49-ddac52daa62f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/2877-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1993589339800482648&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.5823955",
      "poi_longitude": "-97.6399497",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-773-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8e7-7362-a00f-528cd32dd22d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8e7-7362-a00f-528cd32dd22d",
        "storage_key": "property/6767906449165621/019cfb45-b8e7-7362-a00f-528cd32dd22d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYfDqR5wEsocRWDPQKvGmqhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2808a49c-4dc7-4587-ac41-18d95145e188",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Lake Hefner Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "4491 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Golf club with a course, practice area, and pro shop, plus free admission.",
      "poi_long_description": "Golfers say this golf club has nice putting greens and areas to practice chipping, and they appreciate the cheap range balls. They also highlight that it's a great place for both novice and experienced golfers to practice their game.\n\nSome reviews mention the greens can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-09a8-7604-af48-b513096e5691.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-09a8-7604-af48-b513096e5691",
        "storage_key": "property/6767906449165621/019d7913-09a8-7604-af48-b513096e5691.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://okcgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1190782609278487125&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-hefner-golf-club",
      "poi_latitude": "35.5533037",
      "poi_longitude": "-97.6008436",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-843-1565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-43af9f20dbf8",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZ7eItgasocRVcrBXnmChhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_92e00b02-b684-437b-878e-927f3a504d44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Bricktown Entertainment District",
      "poi_type": "Entertainment",
      "poi_address": "111 S Mickey Mantle Dr, Oklahoma City, OK 73104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-10cd-75f7-ba3a-3229891b93f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-10cd-75f7-ba3a-3229891b93f6",
        "storage_key": "property/6767906449165621/019d7913-10cd-75f7-ba3a-3229891b93f6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://welcometobricktown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9363690319686712695&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-entertainment-district",
      "poi_latitude": "35.465041",
      "poi_longitude": "-97.5093544",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-235-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-43af9f20dbf8",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvd56XcwXsocRd72wG7yC8oE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_641fad2b-2553-44bb-aa6b-c267015fc26e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Frontier City",
      "poi_type": "Entertainment",
      "poi_address": "11501 N I- 35 Service Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "Western-themed amusement park offering thrill, kids' & water rides plus multiple shows & eateries.",
      "poi_long_description": "People say this theme park offers a variety of thrill rides, water rides, and live shows. They also highlight the short wait times, fun atmosphere, and friendly staff.\n\nOther reviews mention the parking can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-0e0c-7633-968f-4e3a649bd832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0e0c-7633-968f-4e3a649bd832",
        "storage_key": "property/6767906449165621/019d7913-0e0c-7633-968f-4e3a649bd832.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/frontiercity",
      "poi_directions_map_url": "https://maps.google.com/?cid=7374031908058551867&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "frontier-city",
      "poi_latitude": "35.5856674",
      "poi_longitude": "-97.4394665",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-478-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-43af9f20dbf8",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzIo0KYYsocRO9Y5evPSVWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_cf2fd97b-1086-4f30-993e-5eaa5063956d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A 15-acre facility with formal gardens, a tropical conservatory, a dog park & horticultural classes.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-0f6d-758e-a708-5c26fc2866f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0f6d-758e-a708-5c26fc2866f6",
        "storage_key": "property/6767906449165621/019d7913-0f6d-758e-a708-5c26fc2866f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-43af9f20dbf8",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_93f2a2ca-b3e4-43d5-b97d-00acd9caf18e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "OKC Underground",
      "poi_type": "Entertainment",
      "poi_address": "300 N Broadway Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this tourist attraction offers a fun, family-friendly experience with lots of history. They like that it's free and a great way to learn about the city's past.\n\nSome reviews mention the underground tunnels can be lacking in art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-1957-76ac-a773-f60707273b91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-1957-76ac-a773-f60707273b91",
        "storage_key": "property/6767906449165621/019d7913-1957-76ac-a773-f60707273b91.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://downtownokc.com/underground/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5278230005759075175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "okc-underground",
      "poi_latitude": "35.4701517",
      "poi_longitude": "-97.5141986",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-235-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-43af9f20dbf8",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTcM1aysXsocRZ-MTmDkKQEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_6749e790-ff47-4015-8f8b-ccd63728ff76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Oklahoma City Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "415 Couch Dr, Oklahoma City, OK 73102, USA",
      "poi_short_description": "American art from the colonial era to 1960, plus European paintings & contemporary exhibitions.",
      "poi_long_description": "People say this art museum offers stunning glass displays, beautiful artwork, and a great gift shop. They highlight the free admission on the second Sunday of the month and the tranquil, relaxing vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-19b4-7230-b895-6434d058c4bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-19b4-7230-b895-6434d058c4bc",
        "storage_key": "property/6767906449165621/019d7913-19b4-7230-b895-6434d058c4bc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.okcmoa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9657734537123882826&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-museum-of-art",
      "poi_latitude": "35.4695638",
      "poi_longitude": "-97.5205029",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-236-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-4a0ca11bfbf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-4a0ca11bfbf5",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-4a0ca11bfbf5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_PiwXsocRSmdKhGQqB4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_48d51a5b-9eb7-408d-9151-65ea628fcd55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "poi_name": "Oklahoma Opry",
      "poi_type": "Entertainment",
      "poi_address": "19 E California Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Live music venue featuring local talent and bands.",
      "poi_long_description": "People say this live music venue offers great country music and features talented artists. They highlight the fun, family-friendly atmosphere and the engaging shows. They also like the kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019d7913-3f2e-71cd-960b-8b24974a0c5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3f2e-71cd-960b-8b24974a0c5b",
        "storage_key": "property/6767906449165621/019d7913-3f2e-71cd-960b-8b24974a0c5b.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "http://www.oklahomaopry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3561433270371460881&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-opry",
      "poi_latitude": "35.4656076",
      "poi_longitude": "-97.5112474",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-297-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb45-b8d9-7580-9f3f-43af9f20dbf8",
        "storage_key": "property/6767906449165621/019cfb45-b8d9-7580-9f3f-43af9f20dbf8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6ceUrhsRsocREae_q7DAbDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    }
  ],
  "office_hours": [
    {
      "id": "ec_fe32bb84a9a986987dbcbbce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8820aabfd65137fc0c40e487",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_413a42c7a19990f14ad1efc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e992c771a5058b761e2a43e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5d89e2c2279c86d3f5e6fce5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_abd748c5412a8a9ec2550092",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e601acef-f8c4-4431-b7de-ada360544f68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "rating": "5.0",
      "name": "Shaylee Ochsner",
      "text": "The property manager and all of the office staff are so wonderful. Incredibly helpful and patient. Any issue I’ve ever had, big or small, they’ve been more than willing to help resolve. Which is 10 steps up from every other complex I’ve lived in. The maintenance team is also wonderful, super quick to respond and always friendly and respectful.",
      "date": "2025-05-06",
      "title": ""
    },
    {
      "id": "custom_ae050379-f65d-4d90-8fd5-edeb8084cc66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "rating": "5.0",
      "name": "Mackenzie Robinette",
      "text": "Was dog sitting for a friend. Her neighbors were super nice and the pool was amazing",
      "date": "2025-08-13",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8402c5e8-4808-4820-9f65-d2d9bd103fb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb46-661b-765d-b148-182d6ba65e46.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a kitchen with decorative wallpaper and stainless steel double sink.",
        "public_id": "019cfb46-661b-765d-b148-182d6ba65e46",
        "storage_key": "property/6767906449165621/019cfb46-661b-765d-b148-182d6ba65e46.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Prairie Springs Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d677e267dbd0c25988979"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-80b7-7662-9896-363276888f61",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "prairie-springs-i",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621"
    },
    {
      "lead_collector_id": "019cf79e-812e-7561-ae9d-9cfac72f3f14",
      "lead_source": "LANDING_PAGE",
      "name": "prairie-springs-i",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "harvest-hills-ok-apartments-with-pool",
      "search_query": "apartments with pool in Harvest Hills OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Harvest Hills, OK",
      "h2_subtitle": "Discover beautiful apartments with a pool in Harvest Hills, OK. Enjoy amenities that offer a blend of relaxation and convenience.",
      "page_copy": "Welcome to Prairie Springs, nestled in the serene neighborhood of Harvest Hills in Oklahoma City. Our community offers spacious one, two, and three-bedroom apartments designed with modern amenities. Residents can unwind by the refreshing pool, ideal for relaxation or socializing. Pet owners will appreciate our on-site dog park, making it easy to balance outdoor enjoyment with pet care.\n\nIn addition to the pool, Prairie Springs boasts high-speed internet access and a dedicated property management team, ensuring comfort and ease. Each apartment includes a patio and walk-in closets, offering ample space for storage and leisure. Experience the perfect blend of comfort and convenience in our apartments equipped with a pool in Harvest Hills, OK. Come explore what makes Prairie Springs the ideal home for you and your family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Harvest Hills, OK",
      "seo_description": "Discover Prairie Springs: Apartments with a pool in Harvest Hills, OK. Enjoy top-notch amenities and a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-oklahoma-city",
      "search_query": "dog friendly apartments Oklahoma City",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments Oklahoma City",
      "h2_subtitle": "Explore dog-friendly living in Oklahoma City. Prairie Springs offers ideal amenities for you and your furry companions.",
      "page_copy": "At Prairie Springs, you're not just finding a home; you're joining a community dedicated to pet-friendly living in the heart of Oklahoma City. Our apartments are designed with both humans and their furry friends in mind, featuring an on-site dog park that provides ample room for exercise and socialization. With spacious one, two, and three-bedroom layouts, you'll have plenty of room for you and your pets to thrive.\n\nLocated in the peaceful Harvest Hills neighborhood, Prairie Springs extends a warm welcome to those seeking dog-friendly apartments in Oklahoma City. Our property boasts modern amenities such as a refreshing pool, walk-in closets, high-speed internet access, and more. Whether it's the charming patio spaces or our attentive on-site management, Prairie Springs ensures you and your canine companion have everything needed for a joyful living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments Oklahoma City",
      "seo_description": "Discover dog-friendly apartments at Prairie Springs in Oklahoma City. Perfect for you and your furry friend with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "gated-community-apartments-near-73162",
      "search_query": "gated community apartments near 73162",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments Near 73162",
      "h2_subtitle": "Experience secure living in our gated community apartments near 73162. Discover Prairie Springs, where comfort meets peace of mind.",
      "page_copy": "Prairie Springs provides the ideal blend of security and convenience with our gated community apartments near the 73162 area code. Located in the tranquil Harvest Hills neighborhood, our community ensures peace of mind with various enhanced amenities designed for modern living. Choose from spacious one, two, and three-bedroom floor plans that include walk-in closets and beautiful patio spaces.\n\nResidents enjoy access to a refreshing pool, a well-maintained dog park, and high-speed internet access, making everyday life even more enjoyable. Our diligent on-site management team further ensures a hassle-free living experience, allowing you more time to enjoy the modern conveniences and secure environment that comes with being part of a gated community near 73162.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments Near 73162",
      "seo_description": "Secure living at Prairie Springs with gated community apartments near 73162. Enjoy comfort and convenience in a peaceful location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-harvest-hills",
      "search_query": "apartments with fitness center Harvest Hills",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Harvest Hills",
      "h2_subtitle": "Find your ideal home with a fitness center in Harvest Hills. Prairie Springs offers wellness-focused amenities for active lifestyles.",
      "page_copy": "Discover Prairie Springs, where our community provides a holistic approach to apartment living in the serene Harvest Hills neighborhood. Our spacious one, two, and three-bedroom units are thoughtfully designed to accommodate varying lifestyles, offering walk-in closets and patio spaces perfect for unwinding.\n\nWhile we don't have a fitness center on-site, Prairie Springs ensures residents have access to a variety of amenities such as a refreshing pool and a delightful dog park, fostering an active lifestyle. High-speed internet access and dedicated on-site management further enhance your living experience, allowing you to pursue activities both indoors and out. Explore all the possibilities of vibrant living with Prairie Springs in this welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Harvest Hills",
      "seo_description": "Prairie Springs offers apartments in Harvest Hills with amenities, fostering active lifestyles with a refreshing pool and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "spacious-apartments-patio-oklahoma-city",
      "search_query": "spacious apartments with patio Oklahoma City",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Patio in Oklahoma City",
      "h2_subtitle": "Experience the charm of spacious living in Oklahoma City with patios. Prairie Springs offers an inviting outdoor lifestyle.",
      "page_copy": "Welcome to Prairie Springs in Oklahoma City, where spacious living meets outdoor relaxation. Our community presents a selection of generous one, two, and three-bedroom apartments, each boasting its own private patio. These outdoor spaces allow residents to enjoy the serene atmosphere of the Harvest Hills neighborhood, offering a personal retreat right at home.\n\nInside, you'll find modern kitchens, walk-in closets, and high-speed internet access, ensuring comfort and convenience. Our community amenities, such as a refreshing pool and a dog-friendly park, complement the inviting patios, making Prairie Springs the perfect place to enjoy both indoor comfort and outdoor leisure. Discover the ideal balance of spacious living and scenic settings at Prairie Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Patio in Oklahoma City",
      "seo_description": "Find spacious apartments with patios at Prairie Springs in Oklahoma City. Enjoy outdoor relaxation and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-harvest-hills-ok",
      "search_query": "one bedroom apartments harvest hills ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Harvest Hills, OK",
      "h2_subtitle": "Discover cozy one bedroom apartments in Harvest Hills, OK. Prairie Springs is the perfect place for comfortable living.",
      "page_copy": "Experience the comfort of one-bedroom apartments at Prairie Springs, located in the heart of Harvest Hills, OK. These thoughtfully designed apartment homes feature walk-in closets and private patios, providing an ideal blend of comfort and functionality for individuals or couples.\n\nEnjoy community amenities such as a refreshing pool, a dedicated dog park, and high-speed internet access that enhance your lifestyle. Our on-site management team is committed to maintaining a seamless living experience. Whether you're working from home or seeking a serene neighborhood vibe, Prairie Springs offers one-bedroom apartments that cater to your lifestyle in Harvest Hills, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Harvest Hills, OK",
      "seo_description": "Explore one bedroom apartments at Prairie Springs in Harvest Hills, OK. Enjoy comfort and convenience in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-oklahoma-city",
      "search_query": "two bedroom apartments in oklahoma city",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Oklahoma City",
      "h2_subtitle": "Discover two bedroom apartments in Oklahoma City. Prairie Springs offers a balance of comfort and spaciousness in a vibrant community.",
      "page_copy": "Prairie Springs offers an exceptional living experience with our two-bedroom apartments in Oklahoma City. These residences are perfect for small families or roommates looking to enjoy plenty of space and top-notch amenities. Each apartment features spacious floor plans, walk-in closets, and inviting patios perfect for relaxing after a long day.\n\nNestled in the welcoming Harvest Hills neighborhood, Prairie Springs provides residents with a refreshing pool, a fun dog park, and high-speed internet access. Our attentive on-site management team ensures a hassle-free living environment, making it easier than ever to enjoy everything Oklahoma City has to offer. Explore these inviting two-bedroom apartments and see why Prairie Springs is the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Oklahoma City",
      "seo_description": "Explore spacious two-bedroom apartments at Prairie Springs in Oklahoma City. Enjoy comfort, convenience, and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-73162",
      "search_query": "three bedroom apartments near 73162",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments near 73162",
      "h2_subtitle": "Find spacious three-bedroom apartments near 73162. Prairie Springs offers the perfect blend of comfort and convenience.",
      "page_copy": "Discover the perfect family-sized living space with the three-bedroom apartments available at Prairie Springs, located conveniently near the 73162 area. Our units offer ample room for everyone, boasting spacious interiors with walk-in closets and private patios. Whether hosting guests or enjoying family time, these apartments provide the ideal setup.\n\nPrairie Springs, situated in the vibrant Harvest Hills neighborhood, also offers residents access to a variety of amenities, including a refreshing swimming pool and a dedicated dog park. The on-site management team ensures community well-being, while high-speed internet access makes day-to-day tasks effortlessly efficient. Create lasting memories in our welcoming community by selecting a three-bedroom apartment near the 73162 area at Prairie Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 73162",
      "seo_description": "Explore spacious three-bedroom apartments at Prairie Springs near 73162. Enjoy family-friendly living with excellent amenities in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "apartments-near-southern-nazarene-university-oklahoma-city",
      "search_query": "apartments near southern nazarene university oklahoma city",
      "category": "School",
      "h1_title": "Apartments Near Southern Nazarene University",
      "h2_subtitle": "Explore comfortable apartments near Southern Nazarene University in Oklahoma City. Prairie Springs offers ideal student-friendly living options.",
      "page_copy": "Prairie Springs is your gateway to convenient and comfortable living near Southern Nazarene University in Oklahoma City. Our selection of one, two, and three-bedroom apartments offers students and faculty spacious accommodations with modern amenities like walk-in closets, high-speed internet access, and inviting patios for relaxation.\n\nLocated within easy reach of the Southern Nazarene University campus, Prairie Springs offers a vibrant community atmosphere with features such as a refreshing pool and a pet-friendly dog park. Our dedicated on-site management team ensures a smooth living experience, making it an ideal choice for those pursuing education or working in the area. Discover the perfect balance of convenience and community at Prairie Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Southern Nazarene University OKC",
      "seo_description": "Find student-friendly apartments at Prairie Springs near Southern Nazarene University in Oklahoma City. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "harvest-hills-apartments-near-southwestern-christian-university",
      "search_query": "harvest hills apartments close to southwestern christian university",
      "category": "School",
      "h1_title": "Harvest Hills Apartments Near SCU",
      "h2_subtitle": "Discover Harvest Hills apartments close to Southwestern Christian University. Enjoy convenient living with Prairie Springs' amenities.",
      "page_copy": "Experience a blend of convenience and comfort at Prairie Springs, located in the charming Harvest Hills neighborhood, just a short distance from Southwestern Christian University. Our one, two, and three-bedroom apartments provide a perfect living solution for students and university staff looking for a home close to campus. Each unit boasts features like spacious walk-in closets and cozy patios ideal for study breaks or relaxation.\n\nPrairie Springs enhances resident life with community amenities including a sparkling pool, a fun-filled dog park, and efficient high-speed internet access. The on-site management team is dedicated to your needs, ensuring a worry-free living experience, so you can focus more on your studies or work. Embrace the vibrant lifestyle at Prairie Springs and enjoy the proximity to Southwestern Christian University, making it a favorite choice for those in Harvest Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Harvest Hills Apartments Near Southwestern Christian University",
      "seo_description": "Live near Southwestern Christian University at Prairie Springs in Harvest Hills. Enjoy great amenities and a convenient location in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-baptist-medical-center-oklahoma-city",
      "search_query": "apartments near INTEGRIS Health Baptist Medical Center Oklahoma City",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Health Baptist",
      "h2_subtitle": "Find apartments near INTEGRIS Health Baptist Medical Center in Oklahoma City. Prairie Springs offers convenient living options with great amenities.",
      "page_copy": "At Prairie Springs, enjoy convenient living near INTEGRIS Health Baptist Medical Center in Oklahoma City. Our community offers a variety of spacious apartment options, including one, two, and three-bedroom units, perfectly suited for healthcare professionals and anyone seeking proximity to the medical center. Each apartment is equipped with walk-in closets and private patios, fostering a comfortable and relaxing home environment.\n\nLocated in the peaceful Harvest Hills neighborhood, Prairie Springs offers excellent amenities such as a refreshing pool and a dog-friendly park, enhancing your lifestyle with leisure and pet-friendly options. Our on-site management team is always available to assist residents, ensuring a seamless living experience. Choose Prairie Springs for modern living within easy reach of INTEGRIS Health Baptist Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near INTEGRIS Health Baptist OKC",
      "seo_description": "Explore Prairie Springs apartments near INTEGRIS Health Baptist Medical Center in OKC. Enjoy amenities and proximity to work.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "prairie-springs-oklahoma-city-near-mercy-hospital",
      "search_query": "Prairie Springs Oklahoma City near Mercy Hospital",
      "category": "Hospital",
      "h1_title": "Prairie Springs Near Mercy Hospital",
      "h2_subtitle": "Discover Prairie Springs in Oklahoma City, just minutes from Mercy Hospital. Enjoy convenient living with top-notch amenities.",
      "page_copy": "Welcome to Prairie Springs, ideally located in Oklahoma City and just a short distance from Mercy Hospital. Our community offers a selection of spacious one, two, and three-bedroom apartments, designed to meet the needs of healthcare professionals and staff seeking convenience and comfort. With features like walk-in closets and private patios, Prairie Springs ensures a pleasant living experience.\n\nNestled in the quiet Harvest Hills neighborhood, Prairie Springs features an array of amenities, including a refreshing swimming pool and a pet-friendly dog park. High-speed internet access keeps you connected, while our on-site management provides exceptional service, making Prairie Springs an excellent choice for those who work at Mercy Hospital. Enjoy a lifestyle of ease and accessibility in a supportive community environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Springs Near Mercy Hospital OKC",
      "seo_description": "Live near Mercy Hospital at Prairie Springs, Oklahoma City. Enjoy spacious apartments and convenient amenities close to work.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-oklahoma-city",
      "search_query": "apartments near Martin Park Nature Center Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Martin Park Nature Center OKC",
      "h2_subtitle": "Explore apartments near Martin Park Nature Center in Oklahoma City. Prairie Springs offers a serene setting with convenient access to nature.",
      "page_copy": "Discover the perfect blend of nature and city living at Prairie Springs, located near Martin Park Nature Center in Oklahoma City. Our spacious one, two, and three-bedroom apartments offer a tranquil retreat with walk-in closets and private patios, ideal for those who enjoy outdoor living.\n\nSituated in the scenic Harvest Hills neighborhood, Prairie Springs provides residents with exceptional amenities, including a beautiful swimming pool and a welcoming dog park. High-speed internet access ensures you stay connected, while our dedicated on-site management team supports a hassle-free lifestyle. Experience the joys of being near Martin Park Nature Center, with its walking trails and wildlife, while enjoying the comfortable and convenient living at Prairie Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments Near Martin Park Nature Center",
      "seo_description": "Prairie Springs offers apartments near Martin Park Nature Center in OKC. Enjoy the tranquility and excellent amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "prairie-springs-apartments-close-to-stars-and-stripes-park",
      "search_query": "Prairie Springs apartments close to Stars And Stripes Park",
      "category": "Park",
      "h1_title": "Prairie Springs Near Stars And Stripes Park",
      "h2_subtitle": "Find Prairie Springs apartments close to Stars And Stripes Park in Oklahoma City. Enjoy a vibrant lifestyle with easy access to outdoor fun.",
      "page_copy": "Welcome to Prairie Springs, a community of comfortable and stylish apartments situated close to Stars And Stripes Park in Oklahoma City. Perfectly designed for those who appreciate both city convenience and outdoor recreation, our one, two, and three-bedroom apartments are equipped with spacious walk-in closets and private patios, offering a perfect blend of function and comfort.\n\nLocated in the friendly Harvest Hills neighborhood, Prairie Springs boasts excellent amenities, including a refreshing pool and a pet-friendly environment with a dog park. High-speed internet access is also available, ensuring you remain connected in this bustling area. With on-site management providing exceptional service, Prairie Springs is an ideal home base for exploring nearby Stars And Stripes Park, where you can enjoy picnics, walks, and recreational activities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Springs Apts by Stars And Stripes Park",
      "seo_description": "Experience life at Prairie Springs, near Stars And Stripes Park in OKC. Spacious apartments with great amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-near-bluff-creek-park",
      "search_query": "Oklahoma City apartments near Bluff Creek Park",
      "category": "Park",
      "h1_title": "OKC Apartments Near Bluff Creek Park",
      "h2_subtitle": "Find your new home in Oklahoma City with apartments wonderfully positioned near Bluff Creek Park. Experience both comfort and nature.",
      "page_copy": "Experience comfortable living at Prairie Springs, where Oklahoma City apartments are perfectly located near the serene Bluff Creek Park. Choose from our spacious one, two, or three-bedroom apartments, all featuring thoughtfully designed interiors with walk-in closets and private patios, ideal for enjoying leisurely weekends or a quiet evening under the stars.\n\nLocated in the picturesque Harvest Hills neighborhood, Prairie Springs offers a host of amenities designed to enhance your lifestyle, including a pristine swimming pool and a convenient dog park for your four-legged friends. High-speed internet access keeps you connected, while our attentive on-site management ensures a seamless living experience. Enjoy easy access to the natural beauty and recreational activities of Bluff Creek Park, making Prairie Springs the ideal choice for outdoor enthusiasts and nature lovers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bluff Creek Park OKC",
      "seo_description": "Discover spacious apartments at Prairie Springs, located near Bluff Creek Park in Oklahoma City. Enjoy a cohesive blend of comfort and nearby nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "apartments-near-dolese-park-73162",
      "search_query": "apartments near Dolese Park 73162",
      "category": "Park",
      "h1_title": "Apartments Near Dolese Park 73162",
      "h2_subtitle": "Discover spacious apartments near Dolese Park in the 73162 area. Enjoy the blend of urban convenience and natural beauty at Prairie Springs.",
      "page_copy": "Welcome to Prairie Springs, where you can find beautiful apartments conveniently located near Dolese Park in the 73162 zip code. Choose from a variety of spacious and thoughtfully designed one, two, and three-bedroom apartments, equipped with walk-in closets and private patios that offer the perfect balance of style and comfort.\n\nNestled in the welcoming Harvest Hills neighborhood of Oklahoma City, Prairie Springs provides exceptional amenities such as a refreshing pool and a welcoming dog park, perfect for both relaxation and recreation. With high-speed internet access and responsive on-site management, residents enjoy both convenience and community. Experience the vibrant outdoor activities available at nearby Dolese Park while savoring the comforts of home at Prairie Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments Near Dolese Park 73162",
      "seo_description": "Find your next home at Prairie Springs, with apartments close to Dolese Park in Oklahoma City, 73162. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165621",
      "source": "generator",
      "page_item_url": "prairie-springs-close-to-route-66-park-oklahoma-county",
      "search_query": "Prairie Springs close to Route 66 Park Oklahoma County",
      "category": "Park",
      "h1_title": "Prairie Springs Near Route 66 Park OK County",
      "h2_subtitle": "Live at Prairie Springs, close to Route 66 Park in Oklahoma County. Experience a lifestyle where comfort meets convenience and outdoor adventure.",
      "page_copy": "Prairie Springs offers a unique living experience, situated close to the iconic Route 66 Park in Oklahoma County. Discover one, two, and three-bedroom apartments designed with spacious layouts, walk-in closets, and inviting patios that perfectly complement an active lifestyle.\n\nLocated in the serene Harvest Hills neighborhood of Oklahoma City, Prairie Springs features an array of modern amenities including a sparkling pool and a dedicated dog park, creating a dynamic and community-oriented atmosphere. Stay connected with high-speed internet access and enjoy the convenience of on-site management services. Take advantage of the proximity to Route 66 Park, a perfect destination for leisure and excitement, and make Prairie Springs your ideal home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019cfb45-9354-7010-88cd-cb3fd5fa364c",
        "storage_key": "property/6767906449165621/019cfb45-9354-7010-88cd-cb3fd5fa364c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Springs Near Route 66 Park",
      "seo_description": "Discover Prairie Springs near Route 66 Park in OK County. Enjoy spacious apartments with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5202"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-DPS761QNNN"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151237"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/prairie-springs/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KF2N4G34"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165621/019d1bd6-0e00-7094-b440-3810a7bd6708.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-451-6704"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "67c6a7a82e53737f0256f039"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjMvUjRwOEw4MVpSdlJ2Ny9VT1c1dHc9PSIsInZhbHVlIjoiemNqTmQzM2R1ZWxRaDhaa1FDL3lGZz09IiwibWFjIjoiYjAxMDU5NzUyZGQ3NzVhMGMzNDA1NGM0ZmQ0ZWYwMzQwZGE2ZjcwYTJkNzMyM2I5MWY4ZDgwOTQyYzhmYmI4NyJ9"
    }
  ],
  "custom_qb_id": "5202",
  "custom_ga4_id": "G-DPS761QNNN",
  "custom_repli_id": "10041151237",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/prairie-springs/register/",
  "custom_google_gtm_id": "GTM-KF2N4G34",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165621/019d1bd6-0e00-7094-b440-3810a7bd6708.pdf",
  "custom_ppc_tracking_phone_number": "844-451-6704",
  "custom_residentboost_apartment_id": "67c6a7a82e53737f0256f039",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjMvUjRwOEw4MVpSdlJ2Ny9VT1c1dHc9PSIsInZhbHVlIjoiemNqTmQzM2R1ZWxRaDhaa1FDL3lGZz09IiwibWFjIjoiYjAxMDU5NzUyZGQ3NzVhMGMzNDA1NGM0ZmQ0ZWYwMzQwZGE2ZjcwYTJkNzMyM2I5MWY4ZDgwOTQyYzhmYmI4NyJ9"
};

export const generatedAt = '2026-08-27T21:37:07.325Z';
